(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["casa-apollo-moods"] && !Shopify.designMode) return;
  try {
    
/* Casa Apollo Moods — mobile carousel.
   Clones are rendered SERVER-SIDE in Liquid (the outer
   `for pass in (1..2)` Liquid loop emits each card twice, with
   the second pass tagged `.casa-am__card--clone aria-hidden`).
   CSS hides clones above 640px so desktop sees the static 3-up
   grid. Mobile shows all 6 cards (3 originals + 3 clones) in a
   horizontally-scrollable strip with native iOS swipe momentum.

   Auto-rotation is JS-driven: a rAF loop bumps the viewport's
   scrollLeft at the same pace the old `amMarquee` CSS keyframe
   used (one set width / 7 seconds). The user can interrupt at
   any time by dragging horizontally — pointerdown stops the
   rAF, pointerup schedules a resume ~1.5s later. The shopper
   can also keyboard-arrow through the cards thanks to native
   `overflow-x: auto`. An IntersectionObserver on the section
   root gates everything: the rAF loop (and the vivid lamp's
   hue-cycle, via the .casa-am--anim class) only runs while the
   section is on screen, and never under prefers-reduced-motion.

   Wrap-around: at the moment scrollLeft >= mqShift (one full
   set width), JS instantly subtracts mqShift, jumping the
   container back into the originals zone. Because clone-N
   occupies the exact same on-screen position that original-N
   did one set ago, the jump is visually invisible. */
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(section) {
    var viewport = section.querySelector('[data-am-viewport]');
    var track = section.querySelector('[data-am-track]');
    if (!viewport || !track) return;

    // Clones are already in the DOM from Liquid (data-am-cloned="1"
    // on the track). Block kept as defensive guard.
    if (isMobile() && track.dataset.amCloned !== '1') {
      var originals = Array.from(track.children);
      originals.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('casa-am__card--clone');
        // Remove shopify_attributes from clones so the theme editor
        // doesn't pick a clone when the merchant clicks a card.
        clone.removeAttribute('data-shopify-editor-id');
        track.appendChild(clone);
      });
      track.dataset.amCloned = '1';
    }

    if (isMobile() && !viewport.dataset.amCarouselBound) {
      viewport.dataset.amCarouselBound = '1';

      // --- measurements ---
      // Width of one full set of originals (cards-per-set * (cardW + gap)).
      // Read from the live DOM so the values stay accurate even if a
      // future schema setting tweaks card width or gap.
      function originalCards() {
        return track.querySelectorAll('.casa-am__card:not(.casa-am__card--clone)');
      }
      function computeShift() {
        var cards = originalCards();
        if (!cards.length) return 0;
        var cardW = cards[0].getBoundingClientRect().width;
        var trackCS = getComputedStyle(track);
        var gap = parseFloat(trackCS.columnGap || trackCS.gap) || 14;
        return cards.length * (cardW + gap);
      }
      var mqShift = computeShift();

      // --- auto-rotation pace ---
      // Old keyframe: one set width over 7 seconds → mqShift / 7000 ms/px.
      var PX_PER_MS = mqShift / 7000;

      // --- state ---
      var rafId = null;
      var lastT = 0;
      var paused = false;
      var resumeTimer = null;
      // Also held while the PAGE scrolls vertically (see the window 'scroll'
      // listener below). Writing scrollLeft every frame *during* a page scroll
      // competes with the page's own scroll on iOS's main thread and hitches
      // both, so the strip freezes until the page settles.
      var pageScrolling = false;
      var pageScrollTimer = null;
      // Float scroll position we own. scrollLeft is rounded to whole pixels
      // by mobile WebKit/Blink, so writing the raw fractional accumulator
      // each frame drops the sub-pixel remainder and the cadence stutters
      // between 2px and 3px steps. Carrying the float here and rounding only
      // the write keeps the per-frame advance even, which is the difference
      // between a smooth and a "laggy" marquee.
      var pos = 0;

      function tick(t) {
        // Clamp dt: while the page scrolls, iOS throttles/batches rAF, so a
        // frame can arrive very late. Un-clamped, `pos += PX_PER_MS * dt`
        // jumps a big catch-up step — a visible lurch. Cap at ~2 frames.
        var dt = lastT === 0 ? 0 : Math.min(t - lastT, 32);
        // On (re)start lastT resets to 0 — re-sync our float to the live
        // scroll position so a user drag isn't fought.
        if (lastT === 0) pos = viewport.scrollLeft;
        lastT = t;
        if (!paused && !pageScrolling && !prefersReducedMotion) {
          pos += PX_PER_MS * dt;
          if (pos >= mqShift) pos -= mqShift;
          viewport.scrollLeft = Math.round(pos);
        }
        rafId = requestAnimationFrame(tick);
      }

      function startLoop() {
        if (rafId !== null) return;
        lastT = 0;
        rafId = requestAnimationFrame(tick);
      }
      function stopLoop() {
        if (rafId !== null) cancelAnimationFrame(rafId);
        rafId = null;
      }

      // --- pause on user interaction (drag / keyboard scroll) ---
      function pauseAuto() {
        paused = true;
        if (resumeTimer) {
          clearTimeout(resumeTimer);
          resumeTimer = null;
        }
      }
      function scheduleResume() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          // After the user stops, wrap any cloned-zone position back
          // into originals invisibly before resuming, so the next
          // auto-advance starts from a clean state.
          if (viewport.scrollLeft >= mqShift) {
            viewport.scrollLeft -= mqShift;
          } else if (viewport.scrollLeft < 0) {
            viewport.scrollLeft += mqShift;
          }
          paused = false;
          lastT = 0;
        }, 1500);
      }

      viewport.addEventListener('pointerdown', pauseAuto, { passive: true });
      viewport.addEventListener('pointerup', scheduleResume, { passive: true });
      viewport.addEventListener('pointercancel', scheduleResume, { passive: true });
      // Wheel / trackpad horizontal scroll also counts as user-driven.
      viewport.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
          pauseAuto();
          scheduleResume();
        }
      }, { passive: true });

      // Freeze the auto-advance while the PAGE scrolls vertically. iOS runs
      // page scrolling off the main thread; the marquee's per-frame scrollLeft
      // writes then contend with it and both hitch. Hold the strip still until
      // the page scroll settles (~250ms after the last scroll event), then
      // resume — the lastT reset re-syncs dt so the first frame back doesn't
      // jump. A window 'scroll' event fires only for page/document scroll (an
      // element's own scrollLeft writes don't bubble here), so this never trips
      // on the marquee's own motion. Passive + one debounce timer: no per-frame
      // work, no INP cost.
      function onPageScroll() {
        pageScrolling = true;
        if (pageScrollTimer) clearTimeout(pageScrollTimer);
        pageScrollTimer = setTimeout(function () {
          pageScrolling = false;
          lastT = 0;
        }, 250);
      }
      window.addEventListener('scroll', onPageScroll, { passive: true });
      // Exposed so shopify:section:unload can remove this window listener (the
      // pointer/wheel listeners live on the viewport and GC with the element).
      section.__amPageScrollCleanup = function () {
        window.removeEventListener('scroll', onPageScroll);
        if (pageScrollTimer) { clearTimeout(pageScrollTimer); pageScrollTimer = null; }
        if (resumeTimer) { clearTimeout(resumeTimer); resumeTimer = null; }
      };

      // Recompute mqShift on resize (rotation, browser-chrome change).
      var resizeRaf = 0;
      window.addEventListener('resize', function () {
        if (resizeRaf) cancelAnimationFrame(resizeRaf);
        resizeRaf = requestAnimationFrame(function () {
          mqShift = computeShift();
          PX_PER_MS = mqShift / 7000;
          if (viewport.scrollLeft >= mqShift) viewport.scrollLeft -= mqShift;
        });
      }, { passive: true });

      // Expose start/stop for the visibility gate below (and the
      // shopify:section:unload teardown). The loop is NOT kicked off
      // here — the IntersectionObserver starts it when the section
      // enters the viewport. Manual drag still works regardless
      // because the scroll container is native.
      section.__amStart = startLoop;
      section.__amStop = stopLoop;
    }

    /* Visibility gate — same pattern as casa-aurasphere-scenes: the
       marquee rAF loop and the vivid lamp hue-cycle (CSS class
       .casa-am--anim, see the amVividHue rule in the stylesheet) run
       ONLY while the section is on screen. Enter → add class + start
       the loop; exit → remove class + cancelAnimationFrame. Under
       prefers-reduced-motion neither ever starts — the static cards
       remain fully usable (native scroll, no animation). */
    if (!section.dataset.amIoBound) {
      section.dataset.amIoBound = '1';
      if (!prefersReducedMotion) {
        if ('IntersectionObserver' in window) {
          section.__amIO = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                section.classList.add('casa-am--anim');
                if (section.__amStart) section.__amStart();
              } else {
                section.classList.remove('casa-am--anim');
                if (section.__amStop) section.__amStop();
              }
            });
          }, { threshold: 0.15, rootMargin: '200px' });
          section.__amIO.observe(section);
        } else {
          // No IO support: fall back to always-on (pre-gate behaviour).
          section.classList.add('casa-am--anim');
          if (section.__amStart) section.__amStart();
        }
      }
    }

    /* Phoenix-only ambient overlay sync. Hooks the §05 section to the
       same arm-pattern state §04 dispatches via the
       casa-phoenix-pattern-change CustomEvent. No-op on non-Phoenix
       templates because the `.casa-am__ambient` div is only rendered
       when `template contains 'phoenix'`, and the CSS rules are
       scoped to :root.is-phoenix. The ambient div sits behind every
       content layer at z-index 0; this code positions the 5 blobs
       and updates their colour each time §04 changes pattern. */
    var ambient = section.querySelector('.casa-am__ambient');
    if (ambient && !section.dataset.phxAmbBound) {
      section.dataset.phxAmbBound = '1';
      var phxAmbs = ambient.querySelectorAll('.casa-am__amb');
      /* Anchor Y values span BOTH ends of the overlay so blobs paint
         into BOTH cross-section gaps (2026-05-18 19th pass).
         The overlay is now inset -340px above AND -340px below the
         section, so total overlay height = 680px + section_height.
         Percentages reference the FULL overlay (including extensions).
         - Blobs 0,1: anchored in the upper extension + §05 header area,
           meeting §04's downward overflow at the §04↔§05 gap.
         - Blob 2: in §05's middle (card row area) for ambient sunset
           behind the marquee.
         - Blobs 3,4: anchored in §05's lower half + lower extension,
           meeting §06's upward sunset bloom at the §05↔§06 gap. */
      var PHX_AMB_ANCHOR_Y = [-12, 8, 38, 72, 108]; // % of overlay height
      var PHX_AMB_SPREAD_X = 26;
      var PHX_AMB_SPREAD_Y = 14;

      function phxAmbApply(detail) {
        if (!detail || !detail.armsArr) return;
        var armsArr = detail.armsArr;
        var filmHex = detail.filmHex || [];
        var rect = ambient.getBoundingClientRect();
        var W = rect.width;
        var H = rect.height || 1;
        for (var i = 0; i < 5; i++) {
          var arm = armsArr[i] || { a: 0, f: i };
          var angle = Number(arm.a) || 0;
          var filmIdx = Math.max(0, Math.min(filmHex.length - 1, Number(arm.f) || 0));
          var color = filmHex[filmIdx] || '#E8B86A';
          var rad = angle * Math.PI / 180;
          var xPct = 50 + Math.sin(rad) * PHX_AMB_SPREAD_X;
          var yPct = PHX_AMB_ANCHOR_Y[i] - Math.cos(rad) * PHX_AMB_SPREAD_Y;
          var xPx = xPct * W / 100;
          var yPx = yPct * H / 100;
          if (phxAmbs[i]) {
            phxAmbs[i].style.transform = 'translate(' + xPx + 'px, ' + yPx + 'px) translate(-50%, -50%)';
            phxAmbs[i].style.setProperty('--am-amb-color', color);
          }
        }
      }

      document.addEventListener('casa-phoenix-pattern-change', function (e) {
        phxAmbApply(e.detail);
      });

      /* Cold-start pull. §04 fires its initial event synchronously
         inside its own IIFE; depending on script order, §05's setup
         may run before or after that. Pulling the active pick's
         dataset directly guarantees §05 has the right colours on
         first paint regardless of script timing. */
      var pulled = (function () {
        var arms = document.querySelector('.casa-arms');
        if (!arms) return null;
        var active = arms.querySelector('.casa-arms__pick.is-on') || arms.querySelector('.casa-arms__pick');
        if (!active) return null;
        var armsRaw = active.getAttribute('data-pat-arms') || '[]';
        var filmRaw = (arms.getAttribute('data-film-hex') || '').split(',');
        try {
          return { armsArr: JSON.parse(armsRaw), filmHex: filmRaw };
        } catch (err) {
          return null;
        }
      })();
      if (pulled) phxAmbApply(pulled);

      /* Reposition on viewport resize — same rAF-debounced approach
         §04 uses. Re-applies the last known pattern (cached via the
         is-on pick on §04). */
      var phxResizeRaf = 0;
      window.addEventListener('resize', function () {
        if (phxResizeRaf) return;
        phxResizeRaf = requestAnimationFrame(function () {
          phxResizeRaf = 0;
          var arms = document.querySelector('.casa-arms');
          if (!arms) return;
          var active = arms.querySelector('.casa-arms__pick.is-on');
          if (!active) return;
          var armsRaw = active.getAttribute('data-pat-arms') || '[]';
          var filmRaw = (arms.getAttribute('data-film-hex') || '').split(',');
          try {
            phxAmbApply({ armsArr: JSON.parse(armsRaw), filmHex: filmRaw });
          } catch (err) {}
        });
      }, { passive: true });
    }
  }

  function init() {
    document.querySelectorAll('.casa-am').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('casa-am')) {
      setup(e.target);
    } else if (e.target) {
      var s = e.target.querySelector && e.target.querySelector('.casa-am');
      if (s) setup(s);
    }
  });

  // Theme-editor teardown: stop the rAF loop and disconnect the
  // visibility observer so unmounted sections don't leak.
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    var s = (e.target.classList && e.target.classList.contains('casa-am'))
      ? e.target
      : (e.target.querySelector && e.target.querySelector('.casa-am'));
    if (!s) return;
    if (s.__amStop) s.__amStop();
    if (s.__amPageScrollCleanup) { s.__amPageScrollCleanup(); s.__amPageScrollCleanup = null; }
    if (s.__amIO) { s.__amIO.disconnect(); s.__amIO = null; }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-aurasphere-constellation"] && !Shopify.designMode) return;
  try {
    
(function () {
  function teardown(root) {
    if (root.__cdlCycleId) { clearInterval(root.__cdlCycleId); root.__cdlCycleId = null; }
    if (root.__cdlIO) { root.__cdlIO.disconnect(); root.__cdlIO = null; }
    if (root.__cdlArrowResize) {
      window.removeEventListener('resize', root.__cdlArrowResize);
      root.__cdlArrowResize = null;
    }
    if (root.__cdlArrowFrame) { cancelAnimationFrame(root.__cdlArrowFrame); root.__cdlArrowFrame = null; }
    root.__cdlASConsInit = false;
  }

  // Toggle scroll-arrow visibility based on picker's scroll position.
  // Hidden when there's nothing to scroll to in that direction.
  function bindArrows(root) {
    var picker = root.querySelector('[data-cons-picker]');
    var prev = root.querySelector('[data-cons-arrow="prev"]');
    var next = root.querySelector('[data-cons-arrow="next"]');
    if (!picker || (!prev && !next)) return;

    function update() {
      var sl = picker.scrollLeft;
      var max = picker.scrollWidth - picker.clientWidth;
      var canPrev = sl > 4;
      var canNext = sl < max - 4 && max > 0;
      if (prev) prev.hidden = !canPrev;
      if (next) next.hidden = !canNext;
    }

    function scheduleUpdate() {
      if (root.__cdlArrowFrame) cancelAnimationFrame(root.__cdlArrowFrame);
      root.__cdlArrowFrame = requestAnimationFrame(update);
    }

    function scrollByStep(dir) {
      var step = Math.max(140, Math.round(picker.clientWidth * 0.6));
      picker.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
    if (next) next.addEventListener('click', function () { scrollByStep(1); });
    picker.addEventListener('scroll', scheduleUpdate, { passive: true });
    root.__cdlArrowResize = scheduleUpdate;
    window.addEventListener('resize', root.__cdlArrowResize);
    update();
  }

  function init(root) {
    if (root.__cdlASConsInit) return; root.__cdlASConsInit = true;

    var auraShape = root.dataset.auraShape || 'sphere';
    var patternsNode = root.querySelector('[data-patterns]');
    var poolNode = root.querySelector('[data-scene-pool]');
    if (!patternsNode || !poolNode) return;

    var PATTERNS, POOL;
    try {
      PATTERNS = JSON.parse(patternsNode.textContent);
      POOL = JSON.parse(poolNode.textContent);
    } catch (e) { return; }
    if (!POOL || !POOL.length) {
      POOL = [
        { name: 'Cyan',     hex: '#06B6D4' },
        { name: 'Magenta',  hex: '#EC4899' },
        { name: 'Amber',    hex: '#F97316' },
        { name: 'Emerald',  hex: '#10B981' },
        { name: 'Spectrum', hex: '#9333EA' }
      ];
    }

    var picks = root.querySelectorAll('[data-pattern]');
    var wall = root.querySelector('[data-wall]');
    var capMeta = root.querySelector('[data-cap-meta]');
    var capHint = root.querySelector('[data-cap-hint]');
    var cycleMs = parseInt(root.dataset.cycleMs, 10) || 3000;

    var current = picks[0] && picks[0].dataset.pattern;
    picks.forEach(function (b) { if (b.classList.contains('is-on')) current = b.dataset.pattern; });

    var tickIdx = 0;
    var phase = 0;
    var lastFrame = performance.now();
    var raf;

    function parsePositions(str) {
      if (!str) return [];
      return str.split(';').map(function (s) {
        var parts = s.trim().split(',');
        if (parts.length < 3) return null;
        return { x: parseFloat(parts[0]), y: parseFloat(parts[1]), d: parseFloat(parts[2]) };
      }).filter(Boolean);
    }

    function buildSphere(parent, sceneIdx) {
      var ns = 'http://www.w3.org/2000/svg';
      var s = POOL[sceneIdx % POOL.length];
      var color = s.hex;
      var svg = document.createElementNS(ns, 'svg');
      /* viewBox is 500×500 (not 400×400) so the bloom + blur has 50px of
         bleed room on every side. With r=200 bloom + stdDeviation=10 blur,
         the visible halo extends ~30px past the circle's edge — needs
         padding inside the viewport or the SVG clips it abruptly. */
      svg.setAttribute('viewBox', '0 0 500 500');
      svg.style.color = color;

      var defs = document.createElementNS(ns, 'defs');
      var grad = document.createElementNS(ns, 'radialGradient');
      var gid = 'casphereGrad-' + Math.random().toString(36).slice(2, 8);
      grad.setAttribute('id', gid);
      grad.setAttribute('cx', '50%'); grad.setAttribute('cy', '50%'); grad.setAttribute('r', '50%');
      [
        { o: '0%',   c: 'currentColor', op: 0 },
        { o: '60%',  c: 'currentColor', op: 0 },
        { o: '72%',  c: 'currentColor', op: 0.85 },
        { o: '82%',  c: 'currentColor', op: 0.55 },
        { o: '100%', c: 'currentColor', op: 0 }
      ].forEach(function (st) {
        var n = document.createElementNS(ns, 'stop');
        n.setAttribute('offset', st.o);
        n.setAttribute('stop-color', st.c);
        n.setAttribute('stop-opacity', st.op);
        grad.appendChild(n);
      });
      defs.appendChild(grad);

      var fid = 'casphereFilt-' + Math.random().toString(36).slice(2, 8);
      var filt = document.createElementNS(ns, 'filter');
      filt.setAttribute('id', fid);
      filt.setAttribute('x', '-50%'); filt.setAttribute('y', '-50%');
      filt.setAttribute('width', '200%'); filt.setAttribute('height', '200%');
      var blur = document.createElementNS(ns, 'feGaussianBlur');
      blur.setAttribute('stdDeviation', '10');
      filt.appendChild(blur);
      defs.appendChild(filt);
      // Two-layer LED bloom for non-sphere shapes:
      //   · tight CORE (stdDev=8) → bright luminous edge right at the body
      //   · wide WASH (stdDev=28) → soft ambient glow extending outward
      // Stacking both at full opacity gives a vibrant "LED at the source"
      // look that doesn't read as flat paint.
      var cid = 'casphereCore-' + Math.random().toString(36).slice(2, 8);
      var cfilt = document.createElementNS(ns, 'filter');
      cfilt.setAttribute('id', cid);
      cfilt.setAttribute('x', '-50%'); cfilt.setAttribute('y', '-50%');
      cfilt.setAttribute('width', '200%'); cfilt.setAttribute('height', '200%');
      var cblur = document.createElementNS(ns, 'feGaussianBlur');
      cblur.setAttribute('stdDeviation', '8');
      cfilt.appendChild(cblur);
      defs.appendChild(cfilt);
      var hid = 'casphereHalo-' + Math.random().toString(36).slice(2, 8);
      var hfilt = document.createElementNS(ns, 'filter');
      hfilt.setAttribute('id', hid);
      hfilt.setAttribute('x', '-50%'); hfilt.setAttribute('y', '-50%');
      hfilt.setAttribute('width', '200%'); hfilt.setAttribute('height', '200%');
      var hblur = document.createElementNS(ns, 'feGaussianBlur');
      hblur.setAttribute('stdDeviation', '28');
      hfilt.appendChild(hblur);
      defs.appendChild(hfilt);
      // Ambient halo gradient — radial fade from bright center to
      // FULLY transparent at the outer radius. Applied to a rect that
      // fills the entire viewBox so the visible "edge" of the colored
      // region is the gradient's transparent stop, never a primitive
      // boundary. This eliminates the hard-cut artefact a blurred
      // opaque-rect bloom produces against a dark background.
      var ambId = 'casphereAmb-' + Math.random().toString(36).slice(2, 8);
      var ambGrad = document.createElementNS(ns, 'radialGradient');
      ambGrad.setAttribute('id', ambId);
      ambGrad.setAttribute('cx', '50%'); ambGrad.setAttribute('cy', '50%'); ambGrad.setAttribute('r', '55%');
      [
        { o: '0%',   op: 0.42 },
        { o: '35%',  op: 0.25 },
        { o: '60%',  op: 0.12 },
        { o: '80%',  op: 0.04 },
        { o: '100%', op: 0 }
      ].forEach(function (st) {
        var n = document.createElementNS(ns, 'stop');
        n.setAttribute('offset', st.o);
        n.setAttribute('stop-color', 'currentColor');
        n.setAttribute('stop-opacity', st.op);
        ambGrad.appendChild(n);
      });
      defs.appendChild(ambGrad);
      svg.appendChild(defs);

      /* Light physics: the halo on the wall behind a back-lit LED
         follows the product's perimeter geometry, not always a circle.
           sphere  → solid disc body, ring of light around (circular wash)
           ring    → HOLLOW band, wall lit through the open center too
           panel   → solid square body, SQUARE halo following the perimeter
           frame   → HOLLOW square outline, wall lit through center + around
           edge    → thin vertical bar, VERTICAL elongated halo
         All viewBox 500×500, center (250,250). */
      function el(tag, attrs) {
        var e = document.createElementNS(ns, tag);
        for (var k in attrs) e.setAttribute(k, attrs[k]);
        return e;
      }

      // Per-shape halo + body. The LEDs sit on the BACK of the matte body
      // and bounce off the wall, so the visible glow is a halo around the
      // body's PERIMETER — not a flood-fill of the canvas. Each non-sphere
      // shape renders a heavily-blurred copy of the body in `currentColor`:
      // the blur creates a soft falloff brightest at the body edge and
      // fading both outward (onto surrounding wall) and inward (into the
      // open center for hollow shapes). The full-canvas ambient gradient
      // is sphere-only — for hollow shapes its bright center would leak
      // through the opening and look like paint.

      if (auraShape === 'panel') {
        // Solid square panel — two-layer halo (wide wash + tight core) at
        // full opacity. Wide layer rendered first so it sits behind.
        svg.appendChild(el('rect', { x: 120, y: 120, width: 260, height: 260, rx: 12, ry: 12, fill: 'currentColor', filter: 'url(#' + hid + ')' }));
        svg.appendChild(el('rect', { x: 120, y: 120, width: 260, height: 260, rx: 12, ry: 12, fill: 'currentColor', filter: 'url(#' + cid + ')' }));
        svg.appendChild(el('rect', { x: 120, y: 120, width: 260, height: 260, rx: 8, ry: 8, fill: '#0a0a0e' }));
        svg.appendChild(el('rect', { x: 120, y: 120, width: 260, height: 260, rx: 8, ry: 8, fill: 'none', stroke: 'rgba(255,255,255,0.04)', 'stroke-width': 1 }));
      } else if (auraShape === 'frame') {
        // Hollow square frame — two-layer halo radiates from the aluminum
        // edge both outward AND inward. Even-odd path gives just the
        // outline; tight core + wide wash gives the luminous LED look.
        svg.appendChild(el('path', { d: 'M120 120 H380 V380 H120 Z M138 138 H362 V362 H138 Z', fill: 'currentColor', 'fill-rule': 'evenodd', filter: 'url(#' + hid + ')' }));
        svg.appendChild(el('path', { d: 'M120 120 H380 V380 H120 Z M138 138 H362 V362 H138 Z', fill: 'currentColor', 'fill-rule': 'evenodd', filter: 'url(#' + cid + ')' }));
        svg.appendChild(el('path', { d: 'M120 120 H380 V380 H120 Z M138 138 H362 V362 H138 Z', fill: '#0a0a0e', 'fill-rule': 'evenodd' }));
      } else if (auraShape === 'edge') {
        // Thin vertical bar — two-layer halo bleeds laterally onto walls.
        svg.appendChild(el('rect', { x: 245, y: 50, width: 10, height: 400, rx: 3, ry: 3, fill: 'currentColor', filter: 'url(#' + hid + ')' }));
        svg.appendChild(el('rect', { x: 245, y: 50, width: 10, height: 400, rx: 3, ry: 3, fill: 'currentColor', filter: 'url(#' + cid + ')' }));
        svg.appendChild(el('rect', { x: 245, y: 50, width: 10, height: 400, rx: 3, ry: 3, fill: '#0a0a0e' }));
        svg.appendChild(el('rect', { x: 245, y: 50, width: 10, height: 400, rx: 3, ry: 3, fill: 'none', stroke: 'rgba(255,255,255,0.04)', 'stroke-width': 1 }));
      } else if (auraShape === 'ring') {
        // Hollow ring — two-layer halo from the thin band.
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 130, fill: 'none', stroke: 'currentColor', 'stroke-width': 14, filter: 'url(#' + hid + ')' }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 130, fill: 'none', stroke: 'currentColor', 'stroke-width': 14, filter: 'url(#' + cid + ')' }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 130, fill: 'none', stroke: '#0a0a0e', 'stroke-width': 14 }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 123, fill: 'none', stroke: 'rgba(255,255,255,0.04)', 'stroke-width': 1 }));
      } else {
        // Sphere — full-canvas ambient + wash gradient ring + matte disc.
        // Ambient and wash gradient stops are currentColor with opacity
        // falloff, so they fade to transparent at the viewBox corners.
        svg.appendChild(el('rect', { x: 0, y: 0, width: 500, height: 500, fill: 'url(#' + ambId + ')' }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 180, fill: 'url(#' + gid + ')' }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 130, fill: '#0a0a0e' }));
        svg.appendChild(el('circle', { cx: 250, cy: 250, r: 129, fill: 'none', stroke: 'rgba(255,255,255,0.04)', 'stroke-width': 1 }));
      }

      parent.appendChild(svg);
      return svg;
    }

    function paintPattern(patternKey) {
      while (wall.firstChild) wall.removeChild(wall.firstChild);

      var p = PATTERNS[patternKey];
      if (!p) return;
      var positions = parsePositions(p.positions);
      positions.forEach(function (pos, i) {
        var d = document.createElement('div');
        d.className = 'cdl-as-cons__sphere';
        d.style.left = pos.x + '%';
        d.style.top = pos.y + '%';
        d.style.width = pos.d + '%';
        d.style.aspectRatio = '1 / 1';
        wall.appendChild(d);
        buildSphere(d, tickIdx + i);
      });

      if (capMeta) capMeta.textContent = (p.num || '') + ' · ' + (p.name || '').toUpperCase() + (p.sub ? ' · ' + p.sub.toUpperCase() : '');
      if (capHint) capHint.textContent = p.hint || '';
    }

    picks.forEach(function (b) {
      b.addEventListener('click', function () {
        picks.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        current = b.dataset.pattern;
        paintPattern(current);
      });
    });

    paintPattern(current);
    bindArrows(root);

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // Cycle scene every cycleMs — gated by IntersectionObserver so we
    // don't burn CPU when the section is off-screen.
    function startCycle() {
      if (root.__cdlCycleId) return;
      root.__cdlCycleId = setInterval(function () {
        tickIdx = (tickIdx + 1) % POOL.length;
        paintPattern(current);
      }, cycleMs);
    }
    function stopCycle() {
      if (root.__cdlCycleId) { clearInterval(root.__cdlCycleId); root.__cdlCycleId = null; }
    }

    if ('IntersectionObserver' in window) {
      root.__cdlIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startCycle(); else stopCycle();
        });
      }, { threshold: 0.15 });
      root.__cdlIO.observe(root);
    } else {
      startCycle();
    }
  }

  document.querySelectorAll('.cdl-aurasphere-constellation').forEach(init);
  document.addEventListener('shopify:section:load', function (ev) {
    var node = ev.target.querySelector('.cdl-aurasphere-constellation');
    if (node) { teardown(node); init(node); }
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    var node = ev.target.querySelector('.cdl-aurasphere-constellation');
    if (node) teardown(node);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-aurasphere-placement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.__cdlASPlaceInit) return; root.__cdlASPlaceInit = true;

    var tabs = root.querySelectorAll('[data-scenario]');
    var photos = root.querySelectorAll('[data-photo]');
    var copyEl = root.querySelector('[data-copy]');
    var copyMap = {};
    root.querySelectorAll('[data-copy-for]').forEach(function (n) {
      copyMap[n.dataset.copyFor] = n.textContent;
    });

    function activate(id) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-on', t.dataset.scenario === id);
      });
      photos.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.photo === id);
      });
      if (copyEl && copyMap[id]) copyEl.textContent = copyMap[id];
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        activate(t.dataset.scenario);
      });
    });
  }

  document.querySelectorAll('.cdl-aurasphere-placement').forEach(init);
  document.addEventListener('shopify:section:load', function (ev) {
    var node = ev.target.querySelector('.cdl-aurasphere-placement');
    if (node) init(node);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-aurasphere-scenes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function teardown(root) {
    if (root.__cdlRaf) { cancelAnimationFrame(root.__cdlRaf); root.__cdlRaf = null; }
    if (root.__cdlIO) { root.__cdlIO.disconnect(); root.__cdlIO = null; }
    root.__cdlASInit = false;
  }

  function init(root) {
    if (root.__cdlASInit) return; root.__cdlASInit = true;

    var dataNode = root.querySelector('[data-scenes]');
    if (!dataNode) return;
    var SCENES;
    try { SCENES = JSON.parse(dataNode.textContent); } catch (e) { return; }
    if (!SCENES || !SCENES.length) return;

    var total = SCENES.length;
    var auto  = root.dataset.autoplay === '1';
    var cycle = parseFloat(root.dataset.cycle) || 28;
    var t = 0;
    var phase = 0;
    var raf;
    var last = performance.now();

    var layers = root.querySelectorAll('[data-scene-layer]');
    var photoName = root.querySelector('[data-photo-name]');
    var hudName = root.querySelector('[data-hud-name]');
    var hudHex = root.querySelector('[data-hud-hex]');
    var hudIdx = root.querySelector('[data-hud-idx]');
    var hudSw = root.querySelector('[data-hud-sw]');
    var capKind = root.querySelector('[data-cap-kind]');
    var capTitle = root.querySelector('[data-cap-title]');
    var capBlurb = root.querySelector('[data-cap-blurb]');
    var dots = root.querySelectorAll('[data-dot]');
    var diagramBg = root.querySelector('[data-diagram-bg]');
    var sphereSvg = root.querySelector('[data-sphere-svg]');
    var segmentsG = root.querySelector('[data-segments]');
    var bloom = root.querySelector('[data-bloom]');
    var wash = root.querySelector('[data-wash]');
    var scrubber = root.querySelector('[data-scrubber]');
    var toggleBtn = root.querySelector('[data-toggle]');
    var icoPlay = root.querySelector('[data-ico-play]');
    var icoPause = root.querySelector('[data-ico-pause]');
    var toggleLbl = root.querySelector('[data-toggle-label]');

    function paintToggle(on) {
      if (toggleBtn) toggleBtn.classList.toggle('is-on', on);
      if (icoPlay) icoPlay.hidden = on;
      if (icoPause) icoPause.hidden = !on;
      if (toggleLbl) toggleLbl.textContent = on ? 'Pause' : 'Play';
    }

    function smoothstep(a, b, x) {
      var v = Math.max(0, Math.min(1, (x - a) / (b - a)));
      return v * v * (3 - 2 * v);
    }
    function mixHex(a, b, t) {
      var ah = parseInt(a.slice(1), 16), bh = parseInt(b.slice(1), 16);
      var ar = (ah >> 16) & 255, ag = (ah >> 8) & 255, ab = ah & 255;
      var br = (bh >> 16) & 255, bg = (bh >> 8) & 255, bb = bh & 255;
      var r = Math.round(ar + (br - ar) * t);
      var g = Math.round(ag + (bg - ag) * t);
      var bl = Math.round(ab + (bb - ab) * t);
      return '#' + ((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1);
    }

    var auraShape = root.dataset.auraShape || 'sphere';
    var productNameShort = root.dataset.productName || 'AuraSphere';

    // Non-sphere body shapes (panel/frame/ring/edge) carry data-body; we swap
    // their fill/stroke to the rainbow gradient on multicolor scenes so the
    // front-view diagram matches the multicolor in-situ photo. Sphere has no
    // data-body elements — its LED segments already render the rainbow.
    var bodyFills = root.querySelectorAll('[data-body]');
    var multiGrad = root.querySelector('[data-multi-grad]');
    var MULTI_URL = 'url(#aurasphereMulti-' + root.dataset.sectionId + ')';
    var bodyIsMulti = false; // tracks current paint state to avoid per-frame DOM writes
    // A scene reads as multicolor when it's an animated effect or a multi-* preset
    // (Spectrum / Color Flow / Aurora) — same predicate the sphere segments use.
    function isMulti(scene) {
      return !!scene && (scene.kind === 'EFFECT' || /multi/i.test(scene.id || ''));
    }
    // 24-segment circular LED ring is sphere-only. Other shapes (panel,
    // frame, ring) use continuous LED tape — the wash + bloom alone
    // carry the cycling color.
    var SEGMENTS = auraShape === 'sphere' ? 24 : 0;
    var INNER_R = 130;
    var HALO_R = 180;
    var segPaths = [];
    if (segmentsG && SEGMENTS > 0) {
      var svgNS = 'http://www.w3.org/2000/svg';
      while (segmentsG.firstChild) segmentsG.removeChild(segmentsG.firstChild);
      for (var i = 0; i < SEGMENTS; i++) {
        var a0 = (i / SEGMENTS) * Math.PI * 2 - Math.PI / 2;
        var a1 = ((i + 0.94) / SEGMENTS) * Math.PI * 2 - Math.PI / 2;
        var r0 = INNER_R - 4;
        var r1 = HALO_R;
        var x0a = 200 + r0 * Math.cos(a0), y0a = 200 + r0 * Math.sin(a0);
        var x0b = 200 + r0 * Math.cos(a1), y0b = 200 + r0 * Math.sin(a1);
        var x1a = 200 + r1 * Math.cos(a0), y1a = 200 + r1 * Math.sin(a0);
        var x1b = 200 + r1 * Math.cos(a1), y1b = 200 + r1 * Math.sin(a1);
        var d = 'M ' + x0a + ' ' + y0a + ' L ' + x1a + ' ' + y1a +
                ' A ' + r1 + ' ' + r1 + ' 0 0 1 ' + x1b + ' ' + y1b +
                ' L ' + x0b + ' ' + y0b +
                ' A ' + r0 + ' ' + r0 + ' 0 0 0 ' + x0a + ' ' + y0a + ' Z';
        var p = document.createElementNS(svgNS, 'path');
        p.setAttribute('d', d);
        p.setAttribute('opacity', '0.55');
        segmentsG.appendChild(p);
        segPaths.push(p);
      }
    }

    function paintSegments(scene, phase) {
      for (var i = 0; i < segPaths.length; i++) {
        var color = scene.hex;
        if (scene.kind === 'EFFECT') {
          var hue = ((i / SEGMENTS) * 360 + phase * 360) % 360;
          color = 'hsl(' + hue + ', 78%, 56%)';
        } else if (scene.kind === 'SCENE' && /multi/i.test(scene.id)) {
          color = 'hsl(' + ((i / SEGMENTS) * 360) + ', 80%, 55%)';
        }
        segPaths[i].setAttribute('fill', color);
      }
    }

    function render() {
      var tt = Math.max(0, Math.min(0.9999, t));
      var cont = tt * total;
      var idx = Math.max(0, Math.min(Math.floor(cont), total - 1));
      var localT = cont - idx;
      var cur = SCENES[idx];
      var next = SCENES[(idx + 1) % total];
      var xfade = smoothstep(0.75, 1, localT);
      // Dominant scene during a crossfade drives the multicolor state, matching
      // how the photo layer flips its is-active class at the 50% mark.
      var domScene = xfade < 0.5 ? cur : next;
      var multi = isMulti(domScene);

      // Photo crossfade
      for (var i = 0; i < layers.length; i++) {
        var op = 0;
        if (i === idx) op = 1 - xfade;
        else if (i === (idx + 1) % total) op = xfade;
        layers[i].style.opacity = op;
        if (op > 0.5) layers[i].classList.add('is-active'); else layers[i].classList.remove('is-active');
      }

      // HUD
      var glow = mixHex(cur.hex, next.hex, xfade);
      var MULTI_SWATCH = 'linear-gradient(90deg,#06B6D4,#10B981,#F59E0B,#EC4899,#9333EA)';
      if (hudName) hudName.textContent = (cur.name || '').toUpperCase();
      if (hudHex) hudHex.textContent = multi ? 'MULTI' : glow.toUpperCase();
      if (hudSw) hudSw.style.background = multi ? MULTI_SWATCH : glow;
      if (hudIdx) hudIdx.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      if (photoName) photoName.textContent = productNameShort + ' · ' + cur.name;

      // Caption
      if (capKind) capKind.textContent = (cur.kind || 'STATIC') + ' · ' + String(idx + 1).padStart(2, '0') + ' / ' + String(total).padStart(2, '0');
      if (capTitle) capTitle.textContent = cur.name || '';
      if (capBlurb) capBlurb.textContent = cur.blurb || '';

      // Dots
      for (var d = 0; d < dots.length; d++) {
        if (d === idx) dots[d].classList.add('is-on'); else dots[d].classList.remove('is-on');
      }

      // Diagram color + halo.
      // The SVG color CSS property drives everything: currentColor in the
      // gradient stops + the blurred-body fills resolves to `glow` each
      // frame. Don't override bloom.fill with a solid hex — that destroys
      // the radial gradient on the sphere ambient layer and flood-fills the
      // full viewBox with solid color (was the "looks like paint" bug).
      if (sphereSvg) sphereSvg.style.color = glow;
      if (diagramBg) diagramBg.style.background =
        'radial-gradient(circle at 50% 48%, ' + glow + '33 0%, ' + glow + '10 35%, transparent 65%)';
      if (wash) wash.setAttribute('fill', 'url(#aurasphereWash-' + root.dataset.sectionId + ')');

      // Non-sphere multicolor: swap the body fill/stroke between solid
      // currentColor and the rainbow gradient only when the state changes
      // (avoids a per-frame DOM write), then flow the rainbow while multi.
      if (bodyFills.length) {
        if (multi !== bodyIsMulti) {
          bodyIsMulti = multi;
          for (var bi = 0; bi < bodyFills.length; bi++) {
            var prop = bodyFills[bi].getAttribute('data-body');
            bodyFills[bi].setAttribute(prop, multi ? MULTI_URL : 'currentColor');
          }
        }
        // Only animated EFFECT scenes flow the rainbow. SCENE multi-presets
        // (e.g. Spectrum) are captioned "static rainbow, no animation" — they
        // get the gradient fill but hold still.
        if (multi && multiGrad && domScene && domScene.kind === 'EFFECT') {
          multiGrad.setAttribute('gradientTransform', 'rotate(' + (phase * 360).toFixed(1) + ' 200 200)');
        }
      }

      paintSegments(cur, phase);

      if (scrubber && document.activeElement !== scrubber) {
        scrubber.value = Math.round(t * 1000);
      }
    }

    function tick(now) {
      var dt = (now - last) / 1000; last = now;
      if (auto) {
        t += dt / cycle;
        if (t >= 1) t = 0;
      }
      phase = (phase + dt * 0.4) % 1;
      render();
      root.__cdlRaf = requestAnimationFrame(tick);
    }
    function startTick() {
      if (root.__cdlRaf) return;
      last = performance.now();
      root.__cdlRaf = requestAnimationFrame(tick);
    }
    function stopTick() {
      if (root.__cdlRaf) { cancelAnimationFrame(root.__cdlRaf); root.__cdlRaf = null; }
    }

    if (scrubber) {
      scrubber.addEventListener('input', function () {
        auto = false;
        paintToggle(false);
        t = Number(scrubber.value) / 1000;
      });
    }
    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        auto = !auto;
        paintToggle(auto);
      });
    }
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        auto = false;
        paintToggle(false);
        t = di / total + 0.05;
      });
    });

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      auto = false;
      paintToggle(false);
      render();
      return;
    }

    // Lazy-load scene photos 2-N when the section first enters the viewport.
    function hydrateLayers() {
      if (root.__cdlLayersHydrated) return;
      root.__cdlLayersHydrated = true;
      root.querySelectorAll('[data-scene-layer][data-bg]').forEach(function (el) {
        var url = el.getAttribute('data-bg');
        if (!url) return;
        el.style.backgroundImage = "url('" + url + "')";
        el.removeAttribute('data-bg');
      });
    }

    if ('IntersectionObserver' in window) {
      root.__cdlIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { hydrateLayers(); startTick(); }
          else stopTick();
        });
      }, { threshold: 0.15, rootMargin: '200px' });
      root.__cdlIO.observe(root);
    } else {
      hydrateLayers();
      startTick();
    }
  }

  document.querySelectorAll('.cdl-aurasphere-scenes').forEach(init);
  document.addEventListener('shopify:section:load', function (ev) {
    var node = ev.target.querySelector('.cdl-aurasphere-scenes');
    if (node) { teardown(node); init(node); }
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    var node = ev.target.querySelector('.cdl-aurasphere-scenes');
    if (node) teardown(node);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-color-scene-player"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.cspInit === '1') return;
    root.dataset.cspInit = '1';

    var layers = Array.prototype.slice.call(root.querySelectorAll('.casa-csp__layer'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-csp-go]'));
    var track  = root.querySelector('[data-csp-track]');
    var btn    = root.querySelector('[data-csp-toggle]');
    var label  = root.querySelector('[data-csp-label]');
    var glow   = root.querySelector('.casa-csp__glow');

    var nameEl   = root.querySelector('[data-csp-name]');
    var hexEl    = root.querySelector('[data-csp-hex]');
    var swEl     = root.querySelector('[data-csp-sw]');
    var idxEl    = root.querySelector('[data-csp-index]');
    // NodeLists (not single elements) so split-rail mode's duplicate
    // rail-caption updates in sync with the in-stage overlay caption.
    var kickerEls = root.querySelectorAll('[data-csp-kicker]');
    var titleEls  = root.querySelectorAll('[data-csp-title]');
    var blurbEls  = root.querySelectorAll('[data-csp-blurb]');

    var total = layers.length;
    if (total < 1) return;

    // Mirror the stage's measured width to `--csp-stage-w` on the root so
    // the ctrl row + dots row can be capped at exactly the same width.
    // Stage sizing varies by viewport (desktop: 1:1 square sized inside a
    // width-capped grid column; portrait phones/tablets: width-driven 4:5
    // via the max-aspect-ratio block), so its pixel width can't be matched
    // by a fixed px cap or an svh approximation — measuring it is the only
    // reliable source.
    var stage = root.querySelector('.casa-csp__stage');
    if (stage && typeof ResizeObserver === 'function') {
      if (root._cspRO) root._cspRO.disconnect();
      var ro = new ResizeObserver(function (entries) {
        var w = entries[0].contentRect.width;
        if (w > 0) root.style.setProperty('--csp-stage-w', Math.round(w) + 'px');
      });
      ro.observe(stage);
      root._cspRO = ro;
    }

    var period = parseFloat(root.dataset.period) || 4;
    // Crossfade occupies the last (1 - xfadeStart) of each segment. Widened
    // 2026-07-08 from 0.88 (12%) to 0.70 (30%): at 12% the photo sat frozen
    // for ~2s of each 2.5s hold and read as "paused" on arrival (the loop
    // always starts on the Cyan segment). 30% keeps the scenes visibly
    // dissolving.
    var xfadeStart = 0.70;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.dataset.autoplay === '1' && !prefersReducedMotion;
    var t = 0;
    var jumpStarted = false;
    var rafId = null;
    var last = null;
    // On-screen gate (IntersectionObserver set up at the bottom of init).
    // `auto` is the user's play/pause intent; the rAF loop only actually
    // runs while the section is in the viewport AND auto is on.
    var onScreen = false;
    // Last-written DOM values. render() runs every frame while playing,
    // but for ~88% of each segment nothing visible changes — only write
    // style/textContent when the computed value differs from the last
    // write. Unconditional writes wake the site-wide MutationObserver
    // 60x/s even while the frame is static.
    var lastW = { ops: [], glow: null, color: null, name: null, hex: null, swBg: null, swSh: null, idx: null, kicker: null, title: null, blurb: null, dot: -1, track: null };

    function smoothstep(a, b, x) {
      var v = Math.max(0, Math.min(1, (x - a) / (b - a)));
      return v * v * (3 - 2 * v);
    }
    function mixHex(a, b, p) {
      var ah = parseInt(a.slice(1), 16), bh = parseInt(b.slice(1), 16);
      var ar = (ah >> 16) & 255, ag = (ah >> 8) & 255, ab = ah & 255;
      var br = (bh >> 16) & 255, bg = (bh >> 8) & 255, bb = bh & 255;
      var r = Math.round(ar + (br - ar) * p);
      var g = Math.round(ag + (bg - ag) * p);
      var bl = Math.round(ab + (bb - ab) * p);
      return '#' + ((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1);
    }
    function pad2(n) { return ('0' + n).slice(-2); }

    function render() {
      var cont = t * total;
      var idx = Math.min(Math.floor(cont), total - 1);
      var localT = cont - idx;
      // Crossfade window = the last (1 - xfadeStart) of each segment (30%).
      // Widened from 12% so the photo is never frozen long enough to read as
      // paused; HUD/caption/scrubber still flip together at the fade midpoint.
      var xfade = smoothstep(xfadeStart, 1, localT);
      var nextIdx = (idx + 1) % total;

      for (var i = 0; i < total; i++) {
        var op = 0;
        if (i === idx) op = 1 - xfade;
        else if (i === nextIdx) op = xfade;
        if (lastW.ops[i] !== op) { layers[i].style.opacity = op; lastW.ops[i] = op; }
      }

      var cur = layers[idx];
      var nxt = layers[nextIdx];
      // In-stage glow keeps the smooth single-hex blend (visual continuity
      // through crossfades). The image already shows multi-color light, so
      // a single-hex inner tint reads correctly.
      var glowHex = mixHex(cur.dataset.hex, nxt.dataset.hex, xfade);
      // Multi-stop radial with progressively smaller alpha values — light
      // flows from the lamp body outward, reducing intensity smoothly to
      // transparent at 80% radius. Centered at 50% 55% to sit on the
      // lamp's body (now bottom-anchored at 50% 100% via background-position).
      // Smooth stops + the .casa-csp__glow filter:blur eliminate the
      // banded "chunky" ring artifacts of the prior 3-stop falloff.
      var glowBg = 'radial-gradient(circle at 50% 55%, '
        + glowHex + '40 0%, '
        + glowHex + '2e 18%, '
        + glowHex + '1c 35%, '
        + glowHex + '0e 55%, '
        + 'transparent 80%)';
      if (lastW.glow !== glowBg) { glow.style.background = glowBg; lastW.glow = glowBg; }

      // HUD/caption/dots follow whichever photo is actually dominant on screen.
      // This guarantees the SCENE name + COLOR hex always match the visible lamp.
      var dom        = (xfade > 0.5) ? nxt : cur;
      var domIdx     = (xfade > 0.5) ? nextIdx : idx;
      var domHex     = dom.dataset.hex || glowHex;
      var domPalette = (dom.dataset.palette || '').trim();
      var domColors  = domPalette ? domPalette.split(',').map(function(c){ return c.trim(); }).filter(Boolean) : [];

      // Section-wide ambient bg-glow side bars. For single-color scenes,
      // set --csp-color to the dominant hex — the bg-glow renders a solid
      // colored wash on each side. For multi-color scenes (Holiday, Spectrum,
      // Color Flow), set --csp-color to a vertical linear gradient through
      // the palette so the masked side bars carry every RGB color of the
      // lamp in the image, blurred into continuous flow.
      var cspColor = (domColors.length > 1)
        ? 'linear-gradient(180deg, ' + domColors.join(', ') + ')'
        : domHex;
      if (lastW.color !== cspColor) {
        root.style.setProperty('--csp-color', cspColor);
        lastW.color = cspColor;
      }

      var nameTxt = (dom.dataset.name || '').toUpperCase();
      if (nameEl && lastW.name !== nameTxt) { nameEl.textContent = nameTxt; lastW.name = nameTxt; }
      // Multi-color scenes can't be reduced to a single hex — show MULTI instead so the
      // readout matches the gradient bar segment rather than lying with one color.
      var hexTxt = (domColors.length > 1) ? 'MULTI' : domHex.toUpperCase();
      if (hexEl && lastW.hex !== hexTxt) { hexEl.textContent = hexTxt; lastW.hex = hexTxt; }
      if (swEl) {
        var swBg, swSh;
        if (domColors.length > 1) {
          swBg = 'linear-gradient(90deg, ' + domColors.join(', ') + ')';
          swSh = '0 0 10px ' + domColors[0];
        } else {
          swBg = domHex;
          swSh = '0 0 10px currentColor';
        }
        if (lastW.swBg !== swBg) { swEl.style.background = swBg; lastW.swBg = swBg; }
        if (lastW.swSh !== swSh) { swEl.style.boxShadow  = swSh; lastW.swSh = swSh; }
      }
      var idxTxt = pad2(domIdx + 1) + ' / ' + pad2(total);
      if (idxEl && lastW.idx !== idxTxt) { idxEl.textContent = idxTxt; lastW.idx = idxTxt; }
      var kickerTxt = (dom.dataset.kind || '') + ' · ' + idxTxt;
      if (lastW.kicker !== kickerTxt) {
        kickerEls.forEach(function (el) { el.textContent = kickerTxt; });
        lastW.kicker = kickerTxt;
      }
      var titleTxt = dom.dataset.name || '';
      if (lastW.title !== titleTxt) {
        titleEls.forEach(function (el) { el.textContent = titleTxt; });
        lastW.title = titleTxt;
      }
      var blurbTxt = dom.dataset.blurb || '';
      if (lastW.blurb !== blurbTxt) {
        blurbEls.forEach(function (el) { el.textContent = blurbTxt; });
        lastW.blurb = blurbTxt;
      }

      if (lastW.dot !== domIdx) {
        for (var j = 0; j < dots.length; j++) {
          if (j === domIdx) dots[j].classList.add('is-on'); else dots[j].classList.remove('is-on');
          // Mirror the visual state for assistive tech — .is-on alone is
          // invisible to screen readers.
          dots[j].setAttribute('aria-current', j === domIdx ? 'true' : 'false');
        }
        lastW.dot = domIdx;
      }
      if (track) {
        var trackVal = Math.round(t * 1000);
        if (lastW.track !== trackVal) { track.value = trackVal; lastW.track = trackVal; }
      }
    }

    function tick(now) {
      if (last == null) last = now;
      // Scroll-hold: while the page is actively scrolling, advance
      // nothing and write nothing. The section-wide bg-glow re-rasters
      // a full-section filter:blur(50px) whenever --csp-color
      // transitions, and the stage glow rewrites its gradient every
      // frame through each crossfade — both fed the 2026-07-15 Genix
      // fast-scroll raster white-outs. A crossfade frozen mid-scroll is
      // imperceptible; t resumes exactly where it held once the page
      // settles (same family as the 44974f35 video scroll-settle gate
      // and the anim-gate scroll pause).
      if (cspScrolling) {
        last = now;
        rafId = requestAnimationFrame(tick);
        return;
      }
      var dt = (now - last) / 1000;
      last = now;
      var totalSec = total * period;
      t += dt / totalSec;
      if (t >= 1) t = 0;
      render();
      rafId = requestAnimationFrame(tick);
    }

    // startLoop/stopLoop own the rAF only; start()/stop() own the user's
    // play/pause intent + button paint. The IO gate below drives the loop
    // pair directly so scrolling away never flips the button state.
    function startLoop() {
      if (rafId) return;
      // Jump-start on the first play from a cold start (t≈0). Otherwise the
      // playhead holds on the opening scene for ~(period × xfadeStart) ≈ 1.75s
      // before the first dissolve — which reads as "paused" when the section
      // scrolls into view. Advance it so the first dissolve fires ~0.5s after
      // arrival; later scenes keep the normal rhythm. Fires once, gated on
      // t≈0, so scrolling away and back resumes where it left off (no re-jump).
      if (!jumpStarted && t < 0.001) {
        var leadLocal = 0.5 / period;            // 0.5s expressed as a fraction of one scene
        t = Math.max(0, xfadeStart - leadLocal) / total;
        render();
      }
      jumpStarted = true;
      last = null;
      rafId = requestAnimationFrame(tick);
    }
    function stopLoop() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = null;
    }

    function start() {
      auto = true;
      btn.classList.add('is-on');
      btn.setAttribute('aria-pressed', 'true');
      if (label) label.textContent = btn.dataset.labelPause || 'Pause';
      if (onScreen) startLoop();
    }
    function stop() {
      auto = false;
      btn.classList.remove('is-on');
      btn.setAttribute('aria-pressed', 'false');
      if (label) label.textContent = btn.dataset.labelPlay || 'Play';
      stopLoop();
    }

    btn.addEventListener('click', function () { auto ? stop() : start(); });
    track.addEventListener('input', function (ev) {
      stop();
      t = parseFloat(ev.target.value) / 1000;
      render();
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        var i = parseInt(dot.dataset.cspGo, 10) || 0;
        t = (i + 0.05) / total;
        render();
      });
    });

    // NO pointerenter/pointerleave behavior on the stage — a hover-hold
    // shipped here once and froze playback "randomly" in Safari: Klaviyo's
    // hit-testable onsite layer churns over the stage and fires REAL
    // boundary events under a completely stationary cursor (same root
    // cause as the product-card hover-video flash, af89bdc0). Playback
    // must only stop via the pause button, scrubber/dot interaction, the
    // IO gate, or the scroll latch — never from pointer boundary events.

    render();
    // start() here only paints the Pause state — onScreen is still false,
    // so the rAF loop itself waits for the IO gate below to fire.
    if (auto) start();

    // Only run the rAF loop while the section is actually in the viewport.
    // An ungated autoplay loop rewrites gradients + textContent every frame
    // forever, waking the site-wide MutationObserver 60x/s even when the
    // player is off-screen. Same gate as casa-aurasphere-scenes.
    if (root._cspIO) root._cspIO.disconnect();
    if ('IntersectionObserver' in window) {
      root._cspIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          onScreen = entry.isIntersecting;
          if (onScreen) { if (auto) startLoop(); }
          else stopLoop();
        });
      }, { threshold: 0.15, rootMargin: '200px' });
      root._cspIO.observe(root);
    } else {
      onScreen = true;
      if (auto) startLoop();
    }

    // Theme editor mounts/unmounts sections constantly — release the rAF
    // and both observers when this section unloads.
    root._cspTeardown = function () {
      stopLoop();
      if (root._cspIO) { root._cspIO.disconnect(); root._cspIO = null; }
      if (root._cspRO) { root._cspRO.disconnect(); root._cspRO = null; }
    };
  }

  // Shared scroll latch for every player instance on the page — read by
  // each instance's tick() (see the scroll-hold comment there). Writes
  // happen on scroll-start + settle only, never per scroll frame.
  var cspScrolling = false;
  var cspScrollTimer = null;
  window.addEventListener('scroll', function () {
    cspScrolling = true;
    if (cspScrollTimer) clearTimeout(cspScrollTimer);
    cspScrollTimer = setTimeout(function () {
      cspScrolling = false;
      cspScrollTimer = null;
    }, 200);
  }, { passive: true });

  function bootAll() {
    document.querySelectorAll('.casa-csp').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) ev.target.querySelectorAll('.casa-csp').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev.target) return;
    ev.target.querySelectorAll('.casa-csp').forEach(function (root) {
      if (root._cspTeardown) root._cspTeardown();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-day-night-transform-v3"] && !Shopify.designMode) return;
  try {
    
function casaDnInit(ROOT) {
  if (!ROOT || ROOT.dataset.casaDnInit === '1') return;
  ROOT.dataset.casaDnInit = '1';
  var SECTION_ID = ROOT.dataset.sectionId;

  var $ = function (sel) { return ROOT.querySelector(sel); };

  var stage   = $('[data-casa-dn-stage]');
  var sun     = $('[data-casa-dn-sun]');
  var stars   = $('[data-casa-dn-stars]');
  var dust    = $('[data-casa-dn-dust]');
  var light   = $('[data-casa-dn-light]');
  var off     = $('[data-casa-dn-off]');
  var on      = $('[data-casa-dn-on]');
  var ringsG  = $('[data-casa-dn-rings]');
  var ledHalo = $('[data-casa-dn-led-halo]');
  var ledCore = $('[data-casa-dn-led-core]');
  var pipDot  = $('[data-casa-dn-pip-dot]');
  var pipLbl  = $('[data-casa-dn-pip-lbl]');
  var hudTime  = $('[data-casa-dn-hud-time]');
  var hudPhase = $('[data-casa-dn-hud-phase]');
  var hudLed   = $('[data-casa-dn-hud-led]');
  var capTitle = $('[data-casa-dn-cap-title]');
  var capBody  = $('[data-casa-dn-cap-body]');
  var CAP = {
    aTitle: (ROOT.dataset.capATitle || '').trim(), aBody: (ROOT.dataset.capABody || '').trim(),
    bTitle: (ROOT.dataset.capBTitle || '').trim(), bBody: (ROOT.dataset.capBBody || '').trim(),
    cTitle: (ROOT.dataset.capCTitle || '').trim(), cBody: (ROOT.dataset.capCBody || '').trim()
  };
  var scrub    = $('[data-casa-dn-scrub]');
  var toggle   = $('[data-casa-dn-toggle]');
  var toggleLbl = $('[data-casa-dn-toggle-lbl]');
  var resetBtn = $('[data-casa-dn-reset]');

  if (!stage || !ringsG || !scrub) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var POLY_IN = ROOT.dataset.polyInner || '125,16 275,16 384,125 384,275 275,384 125,384 16,275 16,125';
  var IS_CIRCLE = ROOT.dataset.mirrorShape === 'circle';
  var CIRCLE_CX = parseFloat(ROOT.dataset.circleCx) || 200;
  var CIRCLE_CY = parseFloat(ROOT.dataset.circleCy) || 200;
  var CIRCLE_R_INNER = parseFloat(ROOT.dataset.circleRInner) || 184;
  var VPX = parseFloat(ROOT.dataset.vpX) || 200;
  var VPY = parseFloat(ROOT.dataset.vpY) || 200;

  // Build the 32 nested octagonal rings once. Each gets its own gradient defs.
  var defs = ROOT.querySelector('svg defs');
  var N = 32;
  var ringEls = [];
  for (var i = N - 1; i >= 0; i--) {
    var g = document.createElementNS(SVG_NS, 'g');
    var grad = document.createElementNS(SVG_NS, 'linearGradient');
    var gid = 'casa-dn-r' + SECTION_ID + '-' + i;
    grad.setAttribute('id', gid);
    grad.setAttribute('x1', '0'); grad.setAttribute('y1', '0');
    grad.setAttribute('x2', '1'); grad.setAttribute('y2', '1');
    var stops = [
      ['0%', '#FF2D75'],
      ['16%', '#9333EA'],
      ['33%', '#3B82F6'],
      ['50%', '#06B6D4'],
      ['66%', '#22C55E'],
      ['83%', '#F59E0B'],
      ['100%', '#FF2D75']
    ];
    for (var k = 0; k < stops.length; k++) {
      var st = document.createElementNS(SVG_NS, 'stop');
      st.setAttribute('offset', stops[k][0]);
      st.setAttribute('stop-color', stops[k][1]);
      grad.appendChild(st);
    }
    defs.appendChild(grad);

    var poly;
    if (IS_CIRCLE) {
      poly = document.createElementNS(SVG_NS, 'circle');
      poly.setAttribute('cx', CIRCLE_CX);
      poly.setAttribute('cy', CIRCLE_CY);
      poly.setAttribute('r', CIRCLE_R_INNER);
    } else {
      poly = document.createElementNS(SVG_NS, 'polygon');
      poly.setAttribute('points', POLY_IN);
      poly.setAttribute('stroke-linejoin', 'miter');
    }
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', 'url(#' + gid + ')');

    // Bake static per-ring values at init — avoid setAttribute storms inside rAF.
    // scale, sat, sw, drop-shadow, ring-decay all depend ONLY on i (never change per frame).
    var staticScale = Math.pow(0.90, i);
    var staticSat   = Math.max(55, 100 - i * 1.6);
    var staticSw    = Math.max(0.7, 4.2 * Math.pow(0.95, i));
    var staticDecay = Math.pow(0.93, i);
    g.setAttribute('transform',
      'translate(' + VPX + ' ' + VPY + ') scale(' + staticScale + ') translate(' + (-VPX) + ' ' + (-VPY) + ')');
    g.style.filter = 'saturate(' + staticSat + '%)' + (i < 4 ? ' drop-shadow(0 0 ' + (4-i) + 'px rgba(180,100,255,0.6))' : '');
    g.style.setProperty('--ring-decay', staticDecay);
    g.classList.add('casa-dn__ring');
    poly.setAttribute('stroke-width', staticSw);

    g.appendChild(poly);
    ringsG.appendChild(g);

    ringEls.push({ g: g, poly: poly, grad: grad, i: i });
  }

  // Helpers
  function smoothstep(a, b, x) {
    var t = Math.max(0, Math.min(1, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function hexToRgb(h) {
    return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
  }
  function mix(stops, t) {
    t = clamp(t, 0, 1);
    var n = stops.length - 1;
    var idx = clamp(Math.floor(t * n), 0, n - 1);
    var local = t * n - idx;
    var a = hexToRgb(stops[idx]);
    var b = hexToRgb(stops[idx + 1]);
    return 'rgb(' + Math.round(a[0] + (b[0]-a[0])*local) + ','
                  + Math.round(a[1] + (b[1]-a[1])*local) + ','
                  + Math.round(a[2] + (b[2]-a[2])*local) + ')';
  }

  // Settings
  var autoplay = ROOT.dataset.autoplay === 'true';
  var cycleSeconds = parseFloat(ROOT.dataset.cycleSeconds) || 6;
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduce) { autoplay = false; }

  // State
  var t = 0;
  var auto = autoplay;
  var userOverride = false;
  var rafId = null;

  // Dirty-check helpers — render() runs per frame during the scroll scrub;
  // skip textContent/attribute writes whose value hasn't changed so WebKit
  // doesn't invalidate layout/paint for identical strings.
  var lastWrites = {};
  function setTextDirty(el, key, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.textContent = v; }
  }
  function setAttrDirty(el, key, name, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.setAttribute(name, v); }
  }

  // Render — derive every layer from t
  function render() {
    /* Video stage: the footage IS the render. Everything below animates a
       drawing that is hidden in this mode — a sky gradient, a sun arc, 40
       stars, and a per-ring walk of the SVG tunnel, every frame. Skipping
       it is the difference between one property write and several hundred.
       The HUD and phase captions are skipped too: they report hours, and a
       colour cycle has none. */
    if (videoEl) {
      ROOT.style.setProperty('--casa-dn-t', t.toFixed(3));
      // Fills the hairline from the left. A range input cannot paint its
      // own progress cross-browser, so the position rides a custom
      // property the CSS gradient reads.
      scrub.style.setProperty('--p', (t * 100).toFixed(1) + '%');
      if (document.activeElement !== scrub) {
        var vsv = String(Math.round(t * 1000));
        if (scrub.value !== vsv) scrub.value = vsv;
      }
      return;
    }

    var skyTop    = mix(['var(--casa-paper)','#F4D9C8','#1A1B3A','var(--casa-ink)'], t);
    var skyBottom = mix(['#F2F2EE','#EBA6B5','#241B45','var(--casa-ink)'], t);
    stage.style.background = 'linear-gradient(180deg,' + skyTop + ' 0%,' + skyBottom + ' 100%)';

    // Sun arc
    var sunX = 50 + (t - 0.5) * 70;
    var sunY = 8 + Math.sin(t * Math.PI) * -20 + t * 80;
    var sunOpacity = t < 0.5 ? 1 - t * 0.6 : 1 - (1 - t) * 0.6;
    var sunHue = t < 0.5 ? 'rgba(255,220,140,1)' : 'rgba(220,230,255,0.9)';
    var sunGlow = t < 0.5 ? 'rgba(255,200,100,0.5)' : 'rgba(180,200,255,0.4)';
    sun.style.left = sunX + '%';
    sun.style.top = sunY + '%';
    sun.style.opacity = sunOpacity;
    sun.style.background = 'radial-gradient(circle,' + sunHue + ' 0%,' + sunHue + ' 30%, transparent 70%)';
    sun.style.boxShadow = '0 0 80px 20px ' + sunGlow;

    // Stars + motes
    if (stars) stars.style.opacity = smoothstep(0.55, 0.85, t);
    if (dust)  dust.style.opacity  = (1 - smoothstep(0.2, 0.5, t)) * 0.8;
    if (light) light.style.opacity = smoothstep(0.6, 0.9, t);

    // Publish the clock as a CSS variable so non-SVG stage layers (the
    // photo crossfade) can ride the same 0→1 without a second code path.
    ROOT.style.setProperty('--casa-dn-t', smoothstep(0.35, 0.72, t).toFixed(3));

    // OFF state — fade + desaturate
    var offOpacity = 1 - smoothstep(0.35, 0.65, t);
    off.style.opacity = offOpacity;
    off.style.filter = 'brightness(' + (1 - t * 0.5) + ') saturate(' + (1 - t * 0.7) + ')';

    // ON state
    var onOpacity = smoothstep(0.4, 0.7, t);
    on.style.opacity = onOpacity;

    // Tunnel rings — only `tunnelOpacity` (global) + `phaseRot` (per-ring gradient)
    // change per frame. Static per-ring values (scale/transform/saturate/stroke-width/
    // ring-decay) were baked at init. Opacity is now CSS calc(--tunnel-opacity * --ring-decay).
    var tunnelOpacity = smoothstep(0.55, 0.95, t);
    ringsG.style.setProperty('--tunnel-opacity', tunnelOpacity);
    for (var r = 0; r < ringEls.length; r++) {
      var i = ringEls[r].i;
      var phaseRot = (t * 720 + i * 20) % 360;
      var ringXf = 'rotate(' + phaseRot + ' 0.5 0.5)';
      if (ringEls[r].lastXf !== ringXf) {
        ringEls[r].lastXf = ringXf;
        ringEls[r].grad.setAttribute('gradientTransform', ringXf);
      }
    }

    // Front LED ring (foreground bloom + sharp core)
    var ledRingRot = (t * 720) % 360;
    if (ledHalo) {
      setAttrDirty(ledHalo, 'haloStroke', 'stroke', 'url(#casa-dn-r' + SECTION_ID + '-0)');
      setAttrDirty(ledHalo, 'haloOp', 'opacity', smoothstep(0.45, 0.7, t) * 0.45);
    }
    if (ledCore) {
      setAttrDirty(ledCore, 'coreStroke', 'stroke', 'url(#casa-dn-r' + SECTION_ID + '-0)');
      setAttrDirty(ledCore, 'coreOp', 'opacity', smoothstep(0.42, 0.6, t));
    }

    // Pip
    var pipLit = t >= 0.5;
    var pipColor = pipLit ? 'hsl(' + (280 + t * 80) + ' 80% 60%)' : 'var(--casa-ink)';
    pipDot.style.background = pipColor;
    pipDot.style.boxShadow = pipLit ? ('0 0 12px ' + pipColor) : 'none';
    setTextDirty(pipLbl, 'pipLbl', pipLit ? 'ON · PORTAL' : 'OFF · MIRROR');

    // HUD
    var totalMins = Math.round(14 * 60 + t * 8 * 60);
    var hh = String(Math.floor(totalMins / 60)).padStart(2, '0');
    var mm = String(totalMins % 60).padStart(2, '0');
    var phase = 'AFTERNOON';
    if (t > 0.25) phase = 'GOLDEN HOUR';
    if (t > 0.5)  phase = 'DUSK';
    if (t > 0.7)  phase = 'TWILIGHT';
    if (t > 0.85) phase = 'NIGHT · PORTAL ENGAGED';
    setTextDirty(hudTime, 'hudTime', hh + ':' + mm);
    setTextDirty(hudPhase, 'hudPhase', phase);
    setTextDirty(hudLed, 'hudLed', Math.round(smoothstep(0.45, 0.85, t) * 100) + '%');

    // Caption thresholds. Copy comes from the section settings (data-cap-*
    // on the root) when the merchant filled them in; the literals below are
    // the pre-2026-09-03 defaults and only apply where a setting is blank.
    if (t < 0.4) {
      setTextDirty(capTitle, 'capTitle', CAP.aTitle || 'A mirror, first.');
      setTextDirty(capBody, 'capBody', CAP.aBody || "Hand-crafted glass. Functional, calm. The way a mirror should be.");
    } else if (t < 0.7) {
      setTextDirty(capTitle, 'capTitle', CAP.bTitle || 'The room dims.');
      setTextDirty(capBody, 'capBody', CAP.bBody || 'One tap on the remote. The reflection fades, the LEDs ignite.');
    } else {
      setTextDirty(capTitle, 'capTitle', CAP.cTitle || 'A vault to elsewhere.');
      setTextDirty(capBody, 'capBody', CAP.cBody || '1M+ colors. Music sync. Your scene, your room, your mood.');
    }

    // Sync the scrubber if not currently being dragged
    if (document.activeElement !== scrub) {
      var scrubVal = String(Math.round(t * 1000));
      if (scrub.value !== scrubVal) scrub.value = scrubVal;
    }
  }

  /* Video stage. When present the section stops animating a drawing and
     starts driving real footage. Ownership of the clock flips with play
     state: playing, the video advances itself and reports its position
     back; paused or scrubbing, t seeks it. Two directions, never at once
     — seeking a playing video fights its own decoder. */
  var videoEl = $('[data-casa-dn-video]');

  function videoDuration() {
    // A video with no metadata yet reports NaN/0; guard so a seek during
    // load cannot write NaN into currentTime and wedge playback.
    return (videoEl && isFinite(videoEl.duration) && videoEl.duration > 0)
      ? videoEl.duration : 0;
  }
  function seekVideo(v) {
    var d = videoDuration();
    if (!d) return;
    // Stop just shy of the end: seeking exactly to duration lands past the
    // last frame and some browsers show black.
    videoEl.currentTime = clamp(v, 0, 0.999) * d;
  }

  function setT(v) {
    t = clamp(v, 0, 1);
    if (videoEl) seekVideo(t);
    render();
  }

  // Auto loop
  function startAuto() {
    if (rafId) cancelAnimationFrame(rafId);

    if (videoEl) {
      var p = videoEl.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused; scrub still works */ });
      // The video is now the clock — read from it rather than integrating
      // our own elapsed time, so the scrubber can never drift from what is
      // actually on screen.
      var vtick = function () {
        var d = videoDuration();
        if (d) { t = clamp(videoEl.currentTime / d, 0, 1); render(); }
        rafId = requestAnimationFrame(vtick);
      };
      rafId = requestAnimationFrame(vtick);
      return;
    }

    var last = performance.now();
    function tick(now) {
      var dt = (now - last) / 1000;
      last = now;
      var next = t + dt / cycleSeconds;
      if (next > 1) next = 0;
      t = next;
      render();
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }
  function stopAuto() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    if (videoEl) videoEl.pause();
  }

  // Scroll progress (only when user not overriding AND auto off).
  // rAF ticking pattern (see casa-pdp-features): WebKit delivers several
  // scroll events per frame during momentum scroll — coalesce them so the
  // getBoundingClientRect read + render() writes run at most once per frame.
  // Scroll-linked motion is still motion: bail under prefers-reduced-motion
  // (the CSS kill-switch doesn't cover JS-driven writes).
  var scrollTicking = false;
  var onScroll = function () {
    // Self-clean: theme-editor re-renders replace the section but the old
    // window listener survives — first scroll after removal unhooks it.
    if (!stage.isConnected) { window.removeEventListener('scroll', onScroll); return; }
    if (auto || userOverride || prefersReduce) return;
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      if (auto || userOverride) return;
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      var raw = (vh - rect.top) / (vh - vh * 0.25);
      setT(clamp(raw, 0, 1));
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  // Toggle auto
  toggle.addEventListener('click', function () {
    auto = !auto;
    userOverride = false;
    toggle.classList.toggle('is-on', auto);
    toggleLbl.textContent = auto ? 'Pause' : 'Auto';
    if (auto) startAuto(); else stopAuto();
  });

  // Manual scrub
  scrub.addEventListener('input', function () {
    userOverride = true;
    if (auto) {
      auto = false;
      toggle.classList.remove('is-on');
      toggleLbl.textContent = 'Auto';
      stopAuto();
    }
    setT(parseInt(scrub.value, 10) / 1000);
  });

  // Reset
  resetBtn.addEventListener('click', function () {
    userOverride = false;
    auto = false;
    toggle.classList.remove('is-on');
    toggleLbl.textContent = 'Auto';
    stopAuto();
    setT(0);
  });

  // First paint
  render();

  // Pause the rAF loop when the section scrolls offscreen. The
  // 32-ring tunnel + LED rotation is GPU-cheap but rAF still wakes
  // the main thread every frame; on phones that's measurable
  // battery + scroll-jank cost.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && auto && !rafId) {
          startAuto();
        } else if (!entry.isIntersecting && rafId) {
          stopAuto();
        }
      });
    }, { threshold: 0.01 });
    io.observe(stage);
  } else if (auto) {
    startAuto();
  }
}

function casaDnInitAll(scope) {
  (scope || document).querySelectorAll('.casa-dn').forEach(casaDnInit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { casaDnInitAll(); });
} else {
  casaDnInitAll();
}
document.addEventListener('shopify:section:load', function (e) {
  if (e.target) casaDnInitAll(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-day-night-transform-v5"] && !Shopify.designMode) return;
  try {
    
function casaDnV5Init(ROOT) {
  if (!ROOT || ROOT.dataset.casaDnV5Init === '1') return;
  ROOT.dataset.casaDnV5Init = '1';
  var SECTION_ID = ROOT.dataset.sectionId;

  var $ = function (sel) { return ROOT.querySelector(sel); };

  var stage   = $('[data-casa-dn-v5-stage]');
  var sun     = $('[data-casa-dn-v5-sun]');
  var stars   = $('[data-casa-dn-v5-stars]');
  var dust    = $('[data-casa-dn-v5-dust]');
  var light   = $('[data-casa-dn-v5-light]');
  var off     = $('[data-casa-dn-v5-off]');
  var on      = $('[data-casa-dn-v5-on]');
  var ringsG  = $('[data-casa-dn-v5-rings]');
  var ledHalo = $('[data-casa-dn-v5-led-halo]');
  var ledCore = $('[data-casa-dn-v5-led-core]');
  var pipDot  = $('[data-casa-dn-v5-pip-dot]');
  var pipLbl  = $('[data-casa-dn-v5-pip-lbl]');
  var hudTime  = $('[data-casa-dn-v5-hud-time]');
  var hudPhase = $('[data-casa-dn-v5-hud-phase]');
  var hudLed   = $('[data-casa-dn-v5-hud-led]');
  var capTitle = $('[data-casa-dn-v5-cap-title]');
  var capBody  = $('[data-casa-dn-v5-cap-body]');
  var CAP = {
    aTitle: (ROOT.dataset.capATitle || '').trim(), aBody: (ROOT.dataset.capABody || '').trim(),
    bTitle: (ROOT.dataset.capBTitle || '').trim(), bBody: (ROOT.dataset.capBBody || '').trim(),
    cTitle: (ROOT.dataset.capCTitle || '').trim(), cBody: (ROOT.dataset.capCBody || '').trim()
  };
  var scrub    = $('[data-casa-dn-v5-scrub]');
  var toggle   = $('[data-casa-dn-v5-toggle]');
  var toggleLbl = $('[data-casa-dn-v5-toggle-lbl]');
  var resetBtn = $('[data-casa-dn-v5-reset]');

  if (!stage || !ringsG || !scrub) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var POLY_IN = ROOT.dataset.polyInner || '125,16 275,16 384,125 384,275 275,384 125,384 16,275 16,125';
  var IS_CIRCLE = ROOT.dataset.mirrorShape === 'circle';
  var CIRCLE_CX = parseFloat(ROOT.dataset.circleCx) || 200;
  var CIRCLE_CY = parseFloat(ROOT.dataset.circleCy) || 200;
  var CIRCLE_R_INNER = parseFloat(ROOT.dataset.circleRInner) || 184;
  var VPX = parseFloat(ROOT.dataset.vpX) || 200;
  var VPY = parseFloat(ROOT.dataset.vpY) || 200;

  // Build the 32 nested octagonal rings once. Each gets its own gradient defs.
  var defs = ROOT.querySelector('svg defs');
  var N = 32;
  var ringEls = [];
  for (var i = N - 1; i >= 0; i--) {
    var g = document.createElementNS(SVG_NS, 'g');
    var grad = document.createElementNS(SVG_NS, 'linearGradient');
    var gid = 'casa-dn-v5-r' + SECTION_ID + '-' + i;
    grad.setAttribute('id', gid);
    grad.setAttribute('x1', '0'); grad.setAttribute('y1', '0');
    grad.setAttribute('x2', '1'); grad.setAttribute('y2', '1');
    var stops = [
      ['0%', '#FF2D75'],
      ['16%', '#9333EA'],
      ['33%', '#3B82F6'],
      ['50%', '#06B6D4'],
      ['66%', '#22C55E'],
      ['83%', '#F59E0B'],
      ['100%', '#FF2D75']
    ];
    for (var k = 0; k < stops.length; k++) {
      var st = document.createElementNS(SVG_NS, 'stop');
      st.setAttribute('offset', stops[k][0]);
      st.setAttribute('stop-color', stops[k][1]);
      grad.appendChild(st);
    }
    defs.appendChild(grad);

    var poly;
    if (IS_CIRCLE) {
      poly = document.createElementNS(SVG_NS, 'circle');
      poly.setAttribute('cx', CIRCLE_CX);
      poly.setAttribute('cy', CIRCLE_CY);
      poly.setAttribute('r', CIRCLE_R_INNER);
    } else {
      poly = document.createElementNS(SVG_NS, 'polygon');
      poly.setAttribute('points', POLY_IN);
      poly.setAttribute('stroke-linejoin', 'miter');
    }
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', 'url(#' + gid + ')');

    // Bake static per-ring values at init — avoid setAttribute storms inside rAF.
    // scale, sat, sw, drop-shadow, ring-decay all depend ONLY on i (never change per frame).
    var staticScale = Math.pow(0.90, i);
    var staticSat   = Math.max(55, 100 - i * 1.6);
    var staticSw    = Math.max(0.7, 4.2 * Math.pow(0.95, i));
    var staticDecay = Math.pow(0.93, i);
    g.setAttribute('transform',
      'translate(' + VPX + ' ' + VPY + ') scale(' + staticScale + ') translate(' + (-VPX) + ' ' + (-VPY) + ')');
    g.style.filter = 'saturate(' + staticSat + '%)' + (i < 4 ? ' drop-shadow(0 0 ' + (4-i) + 'px rgba(180,100,255,0.6))' : '');
    g.style.setProperty('--ring-decay', staticDecay);
    g.classList.add('casa-dn-v5__ring');
    poly.setAttribute('stroke-width', staticSw);

    g.appendChild(poly);
    ringsG.appendChild(g);

    ringEls.push({ g: g, poly: poly, grad: grad, i: i });
  }

  // Helpers
  function smoothstep(a, b, x) {
    var t = Math.max(0, Math.min(1, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function hexToRgb(h) {
    return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
  }
  function mix(stops, t) {
    t = clamp(t, 0, 1);
    var n = stops.length - 1;
    var idx = clamp(Math.floor(t * n), 0, n - 1);
    var local = t * n - idx;
    var a = hexToRgb(stops[idx]);
    var b = hexToRgb(stops[idx + 1]);
    return 'rgb(' + Math.round(a[0] + (b[0]-a[0])*local) + ','
                  + Math.round(a[1] + (b[1]-a[1])*local) + ','
                  + Math.round(a[2] + (b[2]-a[2])*local) + ')';
  }

  // Settings
  var autoplay = ROOT.dataset.autoplay === 'true';
  var cycleSeconds = parseFloat(ROOT.dataset.cycleSeconds) || 6;
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduce) { autoplay = false; }

  // State
  var t = 0;
  var auto = autoplay;
  var userOverride = false;
  var rafId = null;
  var autoDirection = 1;

  function syncAutoControl() {
    toggle.classList.toggle('is-on', auto);
    ROOT.classList.toggle('is-paused', !auto);
    toggleLbl.textContent = auto ? 'Pause' : 'Auto';
    toggle.setAttribute('aria-pressed', String(auto));
    toggle.disabled = Boolean(prefersReduce);
    if (prefersReduce) {
      toggle.setAttribute('aria-label', 'Auto animation disabled by reduced motion preference');
    } else {
      toggle.removeAttribute('aria-label');
    }
  }

  // Dirty-check helpers — render() runs per frame during the scroll scrub;
  // skip textContent/attribute writes whose value hasn't changed so WebKit
  // doesn't invalidate layout/paint for identical strings.
  var lastWrites = {};
  function setTextDirty(el, key, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.textContent = v; }
  }
  function setAttrDirty(el, key, name, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.setAttribute(name, v); }
  }

  // Render — derive every layer from t
  function render() {
    /* Video stage: the footage IS the render. Everything below animates a
       drawing that is hidden in this mode — a sky gradient, a sun arc, 40
       stars, and a per-ring walk of the SVG tunnel, every frame. Skipping
       it is the difference between one property write and several hundred.
       The HUD and phase captions are skipped too: they report hours, and a
       colour cycle has none. */
    if (videoEl) {
      ROOT.style.setProperty('--casa-dn-v5-t', t.toFixed(3));
      // Fills the hairline from the left. A range input cannot paint its
      // own progress cross-browser, so the position rides a custom
      // property the CSS gradient reads.
      scrub.style.setProperty('--p', (t * 100).toFixed(1) + '%');
      if (document.activeElement !== scrub) {
        var vsv = String(Math.round(t * 1000));
        if (scrub.value !== vsv) scrub.value = vsv;
      }
      return;
    }

    var skyTop    = mix(['#FAFAF7','#F4D9C8','#1A1B3A','#0A0A0F'], t);
    var skyBottom = mix(['#F2F2EE','#EBA6B5','#241B45','#0A0A0F'], t);
    stage.style.background = 'linear-gradient(180deg,' + skyTop + ' 0%,' + skyBottom + ' 100%)';

    // Sun arc
    var sunX = 50 + (t - 0.5) * 70;
    var sunY = 8 + Math.sin(t * Math.PI) * -20 + t * 80;
    var sunOpacity = t < 0.5 ? 1 - t * 0.6 : 1 - (1 - t) * 0.6;
    var sunHue = t < 0.5 ? 'rgba(255,220,140,1)' : 'rgba(220,230,255,0.9)';
    var sunGlow = t < 0.5 ? 'rgba(255,200,100,0.5)' : 'rgba(180,200,255,0.4)';
    sun.style.left = sunX + '%';
    sun.style.top = sunY + '%';
    sun.style.opacity = sunOpacity;
    sun.style.background = 'radial-gradient(circle,' + sunHue + ' 0%,' + sunHue + ' 30%, transparent 70%)';
    sun.style.boxShadow = '0 0 80px 20px ' + sunGlow;

    // Stars + motes
    if (stars) stars.style.opacity = smoothstep(0.55, 0.85, t);
    if (dust)  dust.style.opacity  = (1 - smoothstep(0.2, 0.5, t)) * 0.8;
    if (light) light.style.opacity = smoothstep(0.6, 0.9, t);

    // Publish the clock as a CSS variable so non-SVG stage layers (the
    // photo crossfade) can ride the same 0→1 without a second code path.
    ROOT.style.setProperty('--casa-dn-v5-t', smoothstep(0.35, 0.72, t).toFixed(3));

    // OFF state — fade + desaturate
    var offOpacity = 1 - smoothstep(0.35, 0.65, t);
    off.style.opacity = offOpacity;
    off.style.filter = 'brightness(' + (1 - t * 0.5) + ') saturate(' + (1 - t * 0.7) + ')';

    // ON state
    var onOpacity = smoothstep(0.4, 0.7, t);
    on.style.opacity = onOpacity;

    // Tunnel rings — only `tunnelOpacity` (global) + `phaseRot` (per-ring gradient)
    // change per frame. Static per-ring values (scale/transform/saturate/stroke-width/
    // ring-decay) were baked at init. Opacity is now CSS calc(--tunnel-opacity * --ring-decay).
    var tunnelOpacity = smoothstep(0.55, 0.95, t);
    ringsG.style.setProperty('--tunnel-opacity', tunnelOpacity);
    for (var r = 0; r < ringEls.length; r++) {
      var i = ringEls[r].i;
      var phaseRot = (t * 720 + i * 20) % 360;
      var ringXf = 'rotate(' + phaseRot + ' 0.5 0.5)';
      if (ringEls[r].lastXf !== ringXf) {
        ringEls[r].lastXf = ringXf;
        ringEls[r].grad.setAttribute('gradientTransform', ringXf);
      }
    }

    // Front LED ring (foreground bloom + sharp core)
    var ledRingRot = (t * 720) % 360;
    if (ledHalo) {
      setAttrDirty(ledHalo, 'haloStroke', 'stroke', 'url(#casa-dn-v5-r' + SECTION_ID + '-0)');
      setAttrDirty(ledHalo, 'haloOp', 'opacity', smoothstep(0.45, 0.7, t) * 0.45);
    }
    if (ledCore) {
      setAttrDirty(ledCore, 'coreStroke', 'stroke', 'url(#casa-dn-v5-r' + SECTION_ID + '-0)');
      setAttrDirty(ledCore, 'coreOp', 'opacity', smoothstep(0.42, 0.6, t));
    }

    // Pip
    var pipLit = t >= 0.5;
    var pipColor = pipLit ? 'hsl(' + (280 + t * 80) + ' 80% 60%)' : 'var(--casa-ink)';
    pipDot.style.background = pipColor;
    pipDot.style.boxShadow = pipLit ? ('0 0 12px ' + pipColor) : 'none';
    setTextDirty(pipLbl, 'pipLbl', pipLit ? 'ON · PORTAL' : 'OFF · MIRROR');

    // HUD
    var totalMins = Math.round(14 * 60 + t * 8 * 60);
    var hh = String(Math.floor(totalMins / 60)).padStart(2, '0');
    var mm = String(totalMins % 60).padStart(2, '0');
    var phase = 'AFTERNOON';
    if (t > 0.25) phase = 'GOLDEN HOUR';
    if (t > 0.5)  phase = 'DUSK';
    if (t > 0.7)  phase = 'TWILIGHT';
    if (t > 0.85) phase = 'NIGHT · PORTAL ENGAGED';
    setTextDirty(hudTime, 'hudTime', hh + ':' + mm);
    setTextDirty(hudPhase, 'hudPhase', phase);
    setTextDirty(hudLed, 'hudLed', Math.round(smoothstep(0.45, 0.85, t) * 100) + '%');

    // Caption thresholds. Copy comes from the section settings (data-cap-*
    // on the root) when the merchant filled them in; the literals below are
    // the pre-2026-09-03 defaults and only apply where a setting is blank.
    if (t < 0.4) {
      setTextDirty(capTitle, 'capTitle', CAP.aTitle || 'A mirror, first.');
      setTextDirty(capBody, 'capBody', CAP.aBody || "Hand-crafted glass. Functional, calm. The way a mirror should be.");
    } else if (t < 0.7) {
      setTextDirty(capTitle, 'capTitle', CAP.bTitle || 'The room dims.');
      setTextDirty(capBody, 'capBody', CAP.bBody || 'One tap on the remote. The reflection fades, the LEDs ignite.');
    } else {
      setTextDirty(capTitle, 'capTitle', CAP.cTitle || 'A vault to elsewhere.');
      setTextDirty(capBody, 'capBody', CAP.cBody || '1M+ colors. Music sync. Your scene, your room, your mood.');
    }

    // Sync the scrubber if not currently being dragged
    if (document.activeElement !== scrub) {
      var scrubVal = String(Math.round(t * 1000));
      if (scrub.value !== scrubVal) scrub.value = scrubVal;
    }
    scrub.setAttribute('aria-valuetext', hh + ':' + mm + ', ' + phase.toLowerCase() + ', LED ' + Math.round(smoothstep(0.45, 0.85, t) * 100) + '%');
  }

  /* Video stage. When present the section stops animating a drawing and
     starts driving real footage. Ownership of the clock flips with play
     state: playing, the video advances itself and reports its position
     back; paused or scrubbing, t seeks it. Two directions, never at once
     — seeking a playing video fights its own decoder. */
  var videoEl = $('[data-casa-dn-v5-video]');

  function videoDuration() {
    // A video with no metadata yet reports NaN/0; guard so a seek during
    // load cannot write NaN into currentTime and wedge playback.
    return (videoEl && isFinite(videoEl.duration) && videoEl.duration > 0)
      ? videoEl.duration : 0;
  }
  function seekVideo(v) {
    var d = videoDuration();
    if (!d) return;
    // Stop just shy of the end: seeking exactly to duration lands past the
    // last frame and some browsers show black.
    videoEl.currentTime = clamp(v, 0, 0.999) * d;
  }

  function setT(v) {
    t = clamp(v, 0, 1);
    if (videoEl) seekVideo(t);
    render();
  }

  // Auto loop
  function startAuto() {
    if (prefersReduce) return;
    if (rafId) cancelAnimationFrame(rafId);

    if (videoEl) {
      var p = videoEl.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused; scrub still works */ });
      // The video is now the clock — read from it rather than integrating
      // our own elapsed time, so the scrubber can never drift from what is
      // actually on screen.
      var vtick = function () {
        var d = videoDuration();
        if (d) { t = clamp(videoEl.currentTime / d, 0, 1); render(); }
        rafId = requestAnimationFrame(vtick);
      };
      rafId = requestAnimationFrame(vtick);
      return;
    }

    var last = performance.now();
    function tick(now) {
      var dt = (now - last) / 1000;
      last = now;
      var next = t + autoDirection * dt / cycleSeconds;
      if (next >= 1) {
        next = 1;
        autoDirection = -1;
      } else if (next <= 0) {
        next = 0;
        autoDirection = 1;
      }
      t = next;
      render();
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }
  function stopAuto() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    if (videoEl) videoEl.pause();
  }

  // Scroll progress (only when user not overriding AND auto off).
  // rAF ticking pattern (see casa-pdp-features): WebKit delivers several
  // scroll events per frame during momentum scroll — coalesce them so the
  // getBoundingClientRect read + render() writes run at most once per frame.
  // Scroll-linked motion is still motion: bail under prefers-reduced-motion
  // (the CSS kill-switch doesn't cover JS-driven writes).
  var scrollTicking = false;
  var onScroll = function () {
    // Self-clean: theme-editor re-renders replace the section but the old
    // window listener survives — first scroll after removal unhooks it.
    if (!stage.isConnected) { window.removeEventListener('scroll', onScroll); return; }
    if (auto || userOverride || prefersReduce) return;
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      if (auto || userOverride) return;
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      var raw = (vh - rect.top) / (vh - vh * 0.25);
      setT(clamp(raw, 0, 1));
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  // Toggle auto
  toggle.addEventListener('click', function () {
    if (prefersReduce) return;
    auto = !auto;
    userOverride = !auto;
    syncAutoControl();
    if (auto) startAuto(); else stopAuto();
  });

  // Manual scrub
  scrub.addEventListener('input', function () {
    userOverride = true;
    if (auto) {
      auto = false;
      syncAutoControl();
      stopAuto();
    }
    setT(parseInt(scrub.value, 10) / 1000);
  });

  // Reset
  resetBtn.addEventListener('click', function () {
    userOverride = true;
    auto = false;
    autoDirection = 1;
    syncAutoControl();
    stopAuto();
    setT(0);
  });

  // First paint
  syncAutoControl();
  render();
  ROOT.dataset.casaDnV5Ready = '1';

  // Pause the rAF loop when the section scrolls offscreen. The
  // 32-ring tunnel + LED rotation is GPU-cheap but rAF still wakes
  // the main thread every frame; on phones that's measurable
  // battery + scroll-jank cost.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && auto && !rafId) {
          startAuto();
        } else if (!entry.isIntersecting && rafId) {
          stopAuto();
        }
      });
    }, { threshold: 0.25 });
    io.observe(stage);
  } else if (auto) {
    startAuto();
  }
}

function casaDnV5InitAll(scope) {
  (scope || document).querySelectorAll('.casa-dn-v5').forEach(casaDnV5Init);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { casaDnV5InitAll(); });
} else {
  casaDnV5InitAll();
}
document.addEventListener('shopify:section:load', function (e) {
  if (e.target) casaDnV5InitAll(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-day-night-transform"] && !Shopify.designMode) return;
  try {
    
function casaDnInit(ROOT) {
  if (!ROOT || ROOT.dataset.casaDnInit === '1') return;
  ROOT.dataset.casaDnInit = '1';
  var SECTION_ID = ROOT.dataset.sectionId;

  var $ = function (sel) { return ROOT.querySelector(sel); };

  var stage   = $('[data-casa-dn-stage]');
  var sun     = $('[data-casa-dn-sun]');
  var stars   = $('[data-casa-dn-stars]');
  var dust    = $('[data-casa-dn-dust]');
  var light   = $('[data-casa-dn-light]');
  var off     = $('[data-casa-dn-off]');
  var on      = $('[data-casa-dn-on]');
  var ringsG  = $('[data-casa-dn-rings]');
  var ledHalo = $('[data-casa-dn-led-halo]');
  var ledCore = $('[data-casa-dn-led-core]');
  var pipDot  = $('[data-casa-dn-pip-dot]');
  var pipLbl  = $('[data-casa-dn-pip-lbl]');
  var hudTime  = $('[data-casa-dn-hud-time]');
  var hudPhase = $('[data-casa-dn-hud-phase]');
  var hudLed   = $('[data-casa-dn-hud-led]');
  var capTitle = $('[data-casa-dn-cap-title]');
  var capBody  = $('[data-casa-dn-cap-body]');
  var scrub    = $('[data-casa-dn-scrub]');
  var toggle   = $('[data-casa-dn-toggle]');
  var toggleLbl = $('[data-casa-dn-toggle-lbl]');
  var resetBtn = $('[data-casa-dn-reset]');

  if (!stage || !ringsG || !scrub) return;

  var SVG_NS = 'http://www.w3.org/2000/svg';
  var POLY_IN = ROOT.dataset.polyInner || '125,16 275,16 384,125 384,275 275,384 125,384 16,275 16,125';
  var IS_CIRCLE = ROOT.dataset.mirrorShape === 'circle';
  var CIRCLE_CX = parseFloat(ROOT.dataset.circleCx) || 200;
  var CIRCLE_CY = parseFloat(ROOT.dataset.circleCy) || 200;
  var CIRCLE_R_INNER = parseFloat(ROOT.dataset.circleRInner) || 184;
  var VPX = parseFloat(ROOT.dataset.vpX) || 200;
  var VPY = parseFloat(ROOT.dataset.vpY) || 200;

  // Build the 32 nested octagonal rings once. Each gets its own gradient defs.
  var defs = ROOT.querySelector('svg defs');
  var N = 32;
  var ringEls = [];
  for (var i = N - 1; i >= 0; i--) {
    var g = document.createElementNS(SVG_NS, 'g');
    var grad = document.createElementNS(SVG_NS, 'linearGradient');
    var gid = 'casa-dn-r' + SECTION_ID + '-' + i;
    grad.setAttribute('id', gid);
    grad.setAttribute('x1', '0'); grad.setAttribute('y1', '0');
    grad.setAttribute('x2', '1'); grad.setAttribute('y2', '1');
    var stops = [
      ['0%', '#FF2D75'],
      ['16%', '#9333EA'],
      ['33%', '#3B82F6'],
      ['50%', '#06B6D4'],
      ['66%', '#22C55E'],
      ['83%', '#F59E0B'],
      ['100%', '#FF2D75']
    ];
    for (var k = 0; k < stops.length; k++) {
      var st = document.createElementNS(SVG_NS, 'stop');
      st.setAttribute('offset', stops[k][0]);
      st.setAttribute('stop-color', stops[k][1]);
      grad.appendChild(st);
    }
    defs.appendChild(grad);

    var poly;
    if (IS_CIRCLE) {
      poly = document.createElementNS(SVG_NS, 'circle');
      poly.setAttribute('cx', CIRCLE_CX);
      poly.setAttribute('cy', CIRCLE_CY);
      poly.setAttribute('r', CIRCLE_R_INNER);
    } else {
      poly = document.createElementNS(SVG_NS, 'polygon');
      poly.setAttribute('points', POLY_IN);
      poly.setAttribute('stroke-linejoin', 'miter');
    }
    poly.setAttribute('fill', 'none');
    poly.setAttribute('stroke', 'url(#' + gid + ')');

    // Bake static per-ring values at init — avoid setAttribute storms inside rAF.
    // scale, sat, sw, drop-shadow, ring-decay all depend ONLY on i (never change per frame).
    var staticScale = Math.pow(0.90, i);
    var staticSat   = Math.max(55, 100 - i * 1.6);
    var staticSw    = Math.max(0.7, 4.2 * Math.pow(0.95, i));
    var staticDecay = Math.pow(0.93, i);
    g.setAttribute('transform',
      'translate(' + VPX + ' ' + VPY + ') scale(' + staticScale + ') translate(' + (-VPX) + ' ' + (-VPY) + ')');
    g.style.filter = 'saturate(' + staticSat + '%)' + (i < 4 ? ' drop-shadow(0 0 ' + (4-i) + 'px rgba(180,100,255,0.6))' : '');
    g.style.setProperty('--ring-decay', staticDecay);
    g.classList.add('casa-dn__ring');
    poly.setAttribute('stroke-width', staticSw);

    g.appendChild(poly);
    ringsG.appendChild(g);

    ringEls.push({ g: g, poly: poly, grad: grad, i: i });
  }

  // Helpers
  function smoothstep(a, b, x) {
    var t = Math.max(0, Math.min(1, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function hexToRgb(h) {
    return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
  }
  function mix(stops, t) {
    t = clamp(t, 0, 1);
    var n = stops.length - 1;
    var idx = clamp(Math.floor(t * n), 0, n - 1);
    var local = t * n - idx;
    var a = hexToRgb(stops[idx]);
    var b = hexToRgb(stops[idx + 1]);
    return 'rgb(' + Math.round(a[0] + (b[0]-a[0])*local) + ','
                  + Math.round(a[1] + (b[1]-a[1])*local) + ','
                  + Math.round(a[2] + (b[2]-a[2])*local) + ')';
  }

  // Settings
  var autoplay = ROOT.dataset.autoplay === 'true';
  var cycleSeconds = parseFloat(ROOT.dataset.cycleSeconds) || 6;
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduce) { autoplay = false; }

  // State
  var t = 0;
  var auto = autoplay;
  var userOverride = false;
  var rafId = null;

  // Dirty-check helpers — render() runs per frame during the scroll scrub;
  // skip textContent/attribute writes whose value hasn't changed so WebKit
  // doesn't invalidate layout/paint for identical strings.
  var lastWrites = {};
  function setTextDirty(el, key, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.textContent = v; }
  }
  function setAttrDirty(el, key, name, v) {
    if (lastWrites[key] !== v) { lastWrites[key] = v; el.setAttribute(name, v); }
  }

  // Render — derive every layer from t
  function render() {
    /* Video stage: the footage IS the render. Everything below animates a
       drawing that is hidden in this mode — a sky gradient, a sun arc, 40
       stars, and a per-ring walk of the SVG tunnel, every frame. Skipping
       it is the difference between one property write and several hundred.
       The HUD and phase captions are skipped too: they report hours, and a
       colour cycle has none. */
    if (videoEl) {
      ROOT.style.setProperty('--casa-dn-t', t.toFixed(3));
      // Fills the hairline from the left. A range input cannot paint its
      // own progress cross-browser, so the position rides a custom
      // property the CSS gradient reads.
      scrub.style.setProperty('--p', (t * 100).toFixed(1) + '%');
      if (document.activeElement !== scrub) {
        var vsv = String(Math.round(t * 1000));
        if (scrub.value !== vsv) scrub.value = vsv;
      }
      return;
    }

    var skyTop    = mix(['var(--casa-paper)','#F4D9C8','#1A1B3A','var(--casa-ink)'], t);
    var skyBottom = mix(['#F2F2EE','#EBA6B5','#241B45','var(--casa-ink)'], t);
    stage.style.background = 'linear-gradient(180deg,' + skyTop + ' 0%,' + skyBottom + ' 100%)';

    // Sun arc
    var sunX = 50 + (t - 0.5) * 70;
    var sunY = 8 + Math.sin(t * Math.PI) * -20 + t * 80;
    var sunOpacity = t < 0.5 ? 1 - t * 0.6 : 1 - (1 - t) * 0.6;
    var sunHue = t < 0.5 ? 'rgba(255,220,140,1)' : 'rgba(220,230,255,0.9)';
    var sunGlow = t < 0.5 ? 'rgba(255,200,100,0.5)' : 'rgba(180,200,255,0.4)';
    sun.style.left = sunX + '%';
    sun.style.top = sunY + '%';
    sun.style.opacity = sunOpacity;
    sun.style.background = 'radial-gradient(circle,' + sunHue + ' 0%,' + sunHue + ' 30%, transparent 70%)';
    sun.style.boxShadow = '0 0 80px 20px ' + sunGlow;

    // Stars + motes
    if (stars) stars.style.opacity = smoothstep(0.55, 0.85, t);
    if (dust)  dust.style.opacity  = (1 - smoothstep(0.2, 0.5, t)) * 0.8;
    if (light) light.style.opacity = smoothstep(0.6, 0.9, t);

    // Publish the clock as a CSS variable so non-SVG stage layers (the
    // photo crossfade) can ride the same 0→1 without a second code path.
    ROOT.style.setProperty('--casa-dn-t', smoothstep(0.35, 0.72, t).toFixed(3));

    // OFF state — fade + desaturate
    var offOpacity = 1 - smoothstep(0.35, 0.65, t);
    off.style.opacity = offOpacity;
    off.style.filter = 'brightness(' + (1 - t * 0.5) + ') saturate(' + (1 - t * 0.7) + ')';

    // ON state
    var onOpacity = smoothstep(0.4, 0.7, t);
    on.style.opacity = onOpacity;

    // Tunnel rings — only `tunnelOpacity` (global) + `phaseRot` (per-ring gradient)
    // change per frame. Static per-ring values (scale/transform/saturate/stroke-width/
    // ring-decay) were baked at init. Opacity is now CSS calc(--tunnel-opacity * --ring-decay).
    var tunnelOpacity = smoothstep(0.55, 0.95, t);
    ringsG.style.setProperty('--tunnel-opacity', tunnelOpacity);
    for (var r = 0; r < ringEls.length; r++) {
      var i = ringEls[r].i;
      var phaseRot = (t * 720 + i * 20) % 360;
      var ringXf = 'rotate(' + phaseRot + ' 0.5 0.5)';
      if (ringEls[r].lastXf !== ringXf) {
        ringEls[r].lastXf = ringXf;
        ringEls[r].grad.setAttribute('gradientTransform', ringXf);
      }
    }

    // Front LED ring (foreground bloom + sharp core)
    var ledRingRot = (t * 720) % 360;
    if (ledHalo) {
      setAttrDirty(ledHalo, 'haloStroke', 'stroke', 'url(#casa-dn-r' + SECTION_ID + '-0)');
      setAttrDirty(ledHalo, 'haloOp', 'opacity', smoothstep(0.45, 0.7, t) * 0.45);
    }
    if (ledCore) {
      setAttrDirty(ledCore, 'coreStroke', 'stroke', 'url(#casa-dn-r' + SECTION_ID + '-0)');
      setAttrDirty(ledCore, 'coreOp', 'opacity', smoothstep(0.42, 0.6, t));
    }

    // Pip
    var pipLit = t >= 0.5;
    var pipColor = pipLit ? 'hsl(' + (280 + t * 80) + ' 80% 60%)' : 'var(--casa-ink)';
    pipDot.style.background = pipColor;
    pipDot.style.boxShadow = pipLit ? ('0 0 12px ' + pipColor) : 'none';
    setTextDirty(pipLbl, 'pipLbl', pipLit ? 'ON · PORTAL' : 'OFF · MIRROR');

    // HUD
    var totalMins = Math.round(14 * 60 + t * 8 * 60);
    var hh = String(Math.floor(totalMins / 60)).padStart(2, '0');
    var mm = String(totalMins % 60).padStart(2, '0');
    var phase = 'AFTERNOON';
    if (t > 0.25) phase = 'GOLDEN HOUR';
    if (t > 0.5)  phase = 'DUSK';
    if (t > 0.7)  phase = 'TWILIGHT';
    if (t > 0.85) phase = 'NIGHT · PORTAL ENGAGED';
    setTextDirty(hudTime, 'hudTime', hh + ':' + mm);
    setTextDirty(hudPhase, 'hudPhase', phase);
    setTextDirty(hudLed, 'hudLed', Math.round(smoothstep(0.45, 0.85, t) * 100) + '%');

    // Caption thresholds
    if (t < 0.4) {
      setTextDirty(capTitle, 'capTitle', 'A mirror, first.');
      setTextDirty(capBody, 'capBody', "Hand-crafted glass. Functional, calm. The way a mirror should be.");
    } else if (t < 0.7) {
      setTextDirty(capTitle, 'capTitle', 'The room dims.');
      setTextDirty(capBody, 'capBody', 'One tap on the remote. The reflection fades, the LEDs ignite.');
    } else {
      setTextDirty(capTitle, 'capTitle', 'A vault to elsewhere.');
      setTextDirty(capBody, 'capBody', '1M+ colors. Music sync. Your scene, your room, your mood.');
    }

    // Sync the scrubber if not currently being dragged
    if (document.activeElement !== scrub) {
      var scrubVal = String(Math.round(t * 1000));
      if (scrub.value !== scrubVal) scrub.value = scrubVal;
    }
  }

  /* Video stage. When present the section stops animating a drawing and
     starts driving real footage. Ownership of the clock flips with play
     state: playing, the video advances itself and reports its position
     back; paused or scrubbing, t seeks it. Two directions, never at once
     — seeking a playing video fights its own decoder. */
  var videoEl = $('[data-casa-dn-video]');

  function videoDuration() {
    // A video with no metadata yet reports NaN/0; guard so a seek during
    // load cannot write NaN into currentTime and wedge playback.
    return (videoEl && isFinite(videoEl.duration) && videoEl.duration > 0)
      ? videoEl.duration : 0;
  }
  function seekVideo(v) {
    var d = videoDuration();
    if (!d) return;
    // Stop just shy of the end: seeking exactly to duration lands past the
    // last frame and some browsers show black.
    videoEl.currentTime = clamp(v, 0, 0.999) * d;
  }

  function setT(v) {
    t = clamp(v, 0, 1);
    if (videoEl) seekVideo(t);
    render();
  }

  // Auto loop
  function startAuto() {
    if (rafId) cancelAnimationFrame(rafId);

    if (videoEl) {
      var p = videoEl.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused; scrub still works */ });
      // The video is now the clock — read from it rather than integrating
      // our own elapsed time, so the scrubber can never drift from what is
      // actually on screen.
      var vtick = function () {
        var d = videoDuration();
        if (d) { t = clamp(videoEl.currentTime / d, 0, 1); render(); }
        rafId = requestAnimationFrame(vtick);
      };
      rafId = requestAnimationFrame(vtick);
      return;
    }

    var last = performance.now();
    function tick(now) {
      var dt = (now - last) / 1000;
      last = now;
      var next = t + dt / cycleSeconds;
      if (next > 1) next = 0;
      t = next;
      render();
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }
  function stopAuto() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    if (videoEl) videoEl.pause();
  }

  // Scroll progress (only when user not overriding AND auto off).
  // rAF ticking pattern (see casa-pdp-features): WebKit delivers several
  // scroll events per frame during momentum scroll — coalesce them so the
  // getBoundingClientRect read + render() writes run at most once per frame.
  // Scroll-linked motion is still motion: bail under prefers-reduced-motion
  // (the CSS kill-switch doesn't cover JS-driven writes).
  var scrollTicking = false;
  var onScroll = function () {
    // Self-clean: theme-editor re-renders replace the section but the old
    // window listener survives — first scroll after removal unhooks it.
    if (!stage.isConnected) { window.removeEventListener('scroll', onScroll); return; }
    if (auto || userOverride || prefersReduce) return;
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      if (auto || userOverride) return;
      var rect = stage.getBoundingClientRect();
      var vh = window.innerHeight;
      var raw = (vh - rect.top) / (vh - vh * 0.25);
      setT(clamp(raw, 0, 1));
    });
  };
  window.addEventListener('scroll', onScroll, { passive: true });

  // Toggle auto
  toggle.addEventListener('click', function () {
    auto = !auto;
    userOverride = false;
    toggle.classList.toggle('is-on', auto);
    toggleLbl.textContent = auto ? 'Pause' : 'Auto';
    if (auto) startAuto(); else stopAuto();
  });

  // Manual scrub
  scrub.addEventListener('input', function () {
    userOverride = true;
    if (auto) {
      auto = false;
      toggle.classList.remove('is-on');
      toggleLbl.textContent = 'Auto';
      stopAuto();
    }
    setT(parseInt(scrub.value, 10) / 1000);
  });

  // Reset
  resetBtn.addEventListener('click', function () {
    userOverride = false;
    auto = false;
    toggle.classList.remove('is-on');
    toggleLbl.textContent = 'Auto';
    stopAuto();
    setT(0);
  });

  // First paint
  render();

  // Pause the rAF loop when the section scrolls offscreen. The
  // 32-ring tunnel + LED rotation is GPU-cheap but rAF still wakes
  // the main thread every frame; on phones that's measurable
  // battery + scroll-jank cost.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && auto && !rafId) {
          startAuto();
        } else if (!entry.isIntersecting && rafId) {
          stopAuto();
        }
      });
    }, { threshold: 0.01 });
    io.observe(stage);
  } else if (auto) {
    startAuto();
  }
}

function casaDnInitAll(scope) {
  (scope || document).querySelectorAll('.casa-dn').forEach(casaDnInit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { casaDnInitAll(); });
} else {
  casaDnInitAll();
}
document.addEventListener('shopify:section:load', function (e) {
  if (e.target) casaDnInitAll(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-multi-lamp-sync"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.mlsInit === '1') return;
    root.dataset.mlsInit = '1';

    var hexes = (root.dataset.cycleHexes || '').split('|').filter(Boolean);
    var names = (root.dataset.cycleNames || '').split('|');
    var totalScenes = hexes.length;
    if (totalScenes < 1) return;
    var cycleMs = parseInt(root.dataset.cycleMs, 10) || 1300;
    var mode = root.dataset.defaultMode === 'zone' ? 'zone' : 'sync';

    // Modern path: one animatable registered <color> (--mls-c) drives the
    // whole lamp, and CSS transitions the cross-fade. This detect MUST
    // mirror the stylesheet's @supports (relative-color) gate exactly, so
    // we never write an inline gradient that shadows the CSS one — nor
    // leave an unsupported browser with no wall-wash at all.
    var MORPH = !!(window.CSS && CSS.supports && CSS.supports('color', 'rgb(from white r g b / 1)'));
    // Fade ≈ 0.75× the dwell: colors flow almost continuously with a brief
    // settle. Clamped so very fast / slow cycle settings still read well.
    var fadeMs = Math.max(240, Math.min(1200, Math.round(cycleMs * 0.75)));
    root.style.setProperty('--mls-fade', fadeMs + 'ms');

    var rooms = Array.prototype.slice.call(root.querySelectorAll('[data-mls-room]'));
    var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-mls-mode]'));
    var tick = 0;

    function paint() {
      rooms.forEach(function (room, i) {
        var offset = mode === 'sync' ? 0 : i;
        var idx = ((tick + offset) % totalScenes + totalScenes) % totalScenes;
        var hex = hexes[idx] || '#06B6D4';

        // Modern path: retarget the one color property; CSS cross-fades
        // the wall-wash gradient, the currentColor edge-rims, and the
        // label color to `hex` together. Nothing else to write per tick.
        // (The label TEXT is handled separately in paintLabels so it can
        // snap at the fade midpoint instead of leading the color.)
        if (MORPH) {
          room.style.setProperty('--mls-c', hex);
          return;
        }

        // ── Legacy discrete path (pre-@property browsers) ──
        var sceneEl = room.querySelector('[data-mls-scene]');
        var glow = room.querySelector('[data-mls-glow]');
        var lampShape = room.dataset.lampShape || 'apollo';
        // Wall-wash radial — the ONLY background emission system in
        // the card. Configuration depends on lamp physics:
        //
        // DEFAULT (apollo, nova, halo, helix, genix) — back-diffuser
        // lamps where the LED sits on the back face of a SOLID body
        // in front of the wall. Strong centered radial, six-stop
        // smooth falloff. The lamp body blocks the brightest peak so
        // what the viewer sees is the wall-wash AROUND the body.
        //
        // INFINITY-FLOOR — the lamp is a hollow black pill frame
        // with the LED diffuser hidden INSIDE the frame channel,
        // facing inward. Light radiates around the frame in a soft
        // organic bounce, not as a strong centered peak behind a
        // solid body. Use a wider, dimmer, ultra-gradual ellipse so
        // the wall reflects color smoothly without ever reading as
        // a hard "filled" rectangle inside the loop's open middle.
        // Max alpha drops from D0(82%) to 50(31%) and the stops
        // taper across many intermediate values for a smooth wash.
        if (glow) {
          if (lampShape === 'infinity-floor') {
            // Loop is hollow + the diffuser sits inside the frame
            // channel. The wall behind the LOOP'S OPEN INTERIOR
            // must stay close to ambient (no centered radial peak
            // there — that would re-introduce the "filled middle"
            // look). But the wall AROUND the loop body should
            // glow brightly with the cycling color, because the
            // diffuser actually radiates in all directions and
            // the wall catches it.
            //
            // Three stacked gradients:
            //   1+2: two bright radials flanking the loop's vertical
            //        sides (41% / 59% horizontal) — peak alpha A0
            //        (62%) so the wall by the lamp glows
            //        distinctly. Wider 30%×85% than before so the
            //        bleed reaches floor + ceiling of the panel.
            //   3:   a wide low-alpha ambient wash centered on the
            //        whole panel (alpha 28 = 16%) — adds room-level
            //        color cast so the lamp feels like it's lighting
            //        the whole space, not just two stripes.
            // The two flanking radials fall off sharply at center
            // (50%), so the loop's open middle still reads
            // essentially as ambient, just gently tinted.
            glow.style.background =
              'radial-gradient(ellipse 30% 85% at 41% 47%, ' + hex + 'A0 0%, ' + hex + '70 20%, ' + hex + '40 45%, ' + hex + '1A 70%, transparent 95%), ' +
              'radial-gradient(ellipse 30% 85% at 59% 47%, ' + hex + 'A0 0%, ' + hex + '70 20%, ' + hex + '40 45%, ' + hex + '1A 70%, transparent 95%), ' +
              'radial-gradient(ellipse 80% 95% at 50% 47%, ' + hex + '28 0%, ' + hex + '14 50%, transparent 90%)';
          } else {
            glow.style.background =
              'radial-gradient(ellipse 70% 100% at 50% 47%, ' + hex + 'D0 0%, ' + hex + '99 12%, ' + hex + '66 25%, ' + hex + '3A 45%, ' + hex + '18 70%, transparent 95%)';
          }
        }

        var lit = room.querySelectorAll('[data-mls-halo], [data-mls-rim]');
        lit.forEach(function (el) { el.setAttribute('fill', hex); });

        // Set CSS color so any remaining `currentColor` references resolve to the scene hex
        var lamp = room.querySelector('.casa-mls__lamp');
        if (lamp) lamp.style.color = hex;

        if (sceneEl) sceneEl.style.color = hex;
      });
    }

    // Scene-label TEXT for the current tick. Kept out of paint() so the
    // word can snap at the color-fade MIDPOINT (see scheduleLabels) — at
    // the smooth fade duration the destination word would otherwise lead
    // the color by nearly a full cycle (very visible on the palette wrap).
    function paintLabels() {
      rooms.forEach(function (room, i) {
        var offset = mode === 'sync' ? 0 : i;
        var idx = ((tick + offset) % totalScenes + totalScenes) % totalScenes;
        var sceneEl = room.querySelector('[data-mls-scene]');
        if (sceneEl) sceneEl.textContent = names[idx] || 'Scene';
      });
    }
    // Modern: swap words half-way through the color fade so they track the
    // hue. Legacy hard-cuts, so update immediately in lockstep.
    function scheduleLabels() {
      if (root.__mlsLabelT) { clearTimeout(root.__mlsLabelT); root.__mlsLabelT = null; }
      if (MORPH) root.__mlsLabelT = setTimeout(paintLabels, Math.round(fadeMs * 0.5));
      else paintLabels();
    }

    function setMode(next) {
      mode = next;
      modeBtns.forEach(function (b) {
        var on = b.dataset.mlsMode === next;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      paint();
      paintLabels();
    }

    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.mlsMode); });
    });

    // Commit the first scene's colors WITHOUT a transition (warmup guard),
    // then a reflow, then re-enable fades — so the initial hydration snaps
    // to scene 0 instead of sweeping there from the cyan seed.
    root.dataset.mlsWarmup = '';
    paint();
    paintLabels();
    void root.offsetWidth;
    delete root.dataset.mlsWarmup;

    // Static first scene under reduced motion — the paint above renders
    // the initial state; skip the cycling interval entirely.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    // Cycle scene every cycleMs — gated by IntersectionObserver so the
    // feGaussianBlur-filtered shapes aren't re-rastered while the
    // section is off-screen (each repaint forces a CPU filter pass).
    function startCycle() {
      if (root.__mlsCycleId) return;
      root.__mlsCycleId = setInterval(function () { tick = (tick + 1) % totalScenes; paint(); scheduleLabels(); }, cycleMs);
    }
    function stopCycle() {
      if (root.__mlsCycleId) { clearInterval(root.__mlsCycleId); root.__mlsCycleId = null; }
      if (root.__mlsLabelT) { clearTimeout(root.__mlsLabelT); root.__mlsLabelT = null; }
    }

    if ('IntersectionObserver' in window) {
      root.__mlsIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) startCycle(); else stopCycle();
        });
      }, { threshold: 0.15 });
      root.__mlsIO.observe(root);
    } else {
      startCycle();
    }
  }

  function teardown(root) {
    if (!root) return;
    if (root.__mlsCycleId) { clearInterval(root.__mlsCycleId); root.__mlsCycleId = null; }
    if (root.__mlsLabelT) { clearTimeout(root.__mlsLabelT); root.__mlsLabelT = null; }
    if (root.__mlsIO) { root.__mlsIO.disconnect(); root.__mlsIO = null; }
    delete root.dataset.mlsInit;
  }

  function bootAll() {
    document.querySelectorAll('.casa-mls').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) ev.target.querySelectorAll('.casa-mls').forEach(function (node) { teardown(node); init(node); });
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (ev.target) ev.target.querySelectorAll('.casa-mls').forEach(teardown);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-answers-v6"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('casa-answers-v6')) {
    customElements.define('casa-answers-v6', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const root = this.querySelector('.casa-v6-answers');
        const input = this.querySelector('[data-answer-search]');
        const items = [...this.querySelectorAll('[data-casa-v6-faq]')];
        const topics = [...this.querySelectorAll('[data-topic]')];
        const fold = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[-–—]/g, '');
        const text = new Map(items.map(item => [item, fold(item.textContent)]));
        const title = this.querySelector('[data-results-title]');
        const status = this.querySelector('[data-answer-status]');
        const clear = this.querySelector('[data-clear-search]');
        let selected = 'popular';
        let timer;
        topics.forEach(button => {
          const key = button.dataset.topic;
          button.querySelector('[data-topic-count]').textContent = items.filter(item => key === 'popular' ? item.dataset.startHere === 'true' : item.dataset.group === key).length;
          button.addEventListener('click', () => { selected = key; input.value = ''; update(); }, { signal });
        });
        const update = () => {
          const query = fold(input.value.trim());
          const terms = query.split(/\s+/).filter(Boolean);
          let count = 0;
          items.forEach(item => {
            const show = query ? terms.every(term => text.get(item).includes(term)) : selected === 'popular' ? item.dataset.startHere === 'true' : item.dataset.group === selected;
            item.hidden = !show;
            if (show) count++;
          });
          topics.forEach(button => button.setAttribute('aria-pressed', String(!query && button.dataset.topic === selected)));
          title.textContent = query ? input.getAttribute('placeholder') : topics.find(button => button.dataset.topic === selected).firstElementChild.textContent;
          status.textContent = `${count} / ${items.length}`;
          clear.hidden = !query;
          this.querySelector('[data-answer-empty]').hidden = count !== 0;
        };
        input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(update, 100); }, { signal });
        input.addEventListener('keydown', event => { if (event.key === 'Escape') { input.value = ''; update(); } }, { signal });
        clear.addEventListener('click', () => { input.value = ''; update(); input.focus(); }, { signal });
        root.dataset.enhanced = '';
        this.querySelector('.casa-v6-answers__nav').hidden = false;
        this.querySelector('.casa-v6-answers__search').hidden = false;
        this.querySelector('.casa-v6-answers__result').hidden = false;
        update();
        signal.addEventListener('abort', () => clearTimeout(timer), { once: true });
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-answers-v7"] && !Shopify.designMode) return;
  try {
    
  function initializeCasaV7AnswerTabs(scope) {
    const roots = scope.querySelectorAll('.casa-v7-answers:not([data-v7-tabs-ready])');
    roots.forEach((root) => {
      root.dataset.v7TabsReady = 'true';
      const tabs = Array.from(root.querySelectorAll('[data-v7-answer-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-v7-answer-panel]'));

      const activate = (key, focusTab) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.v7AnswerTab === key;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });
        panels.forEach((panel) => {
          const active = panel.dataset.v7AnswerPanel === key;
          panel.hidden = !active;
          if (!active) panel.querySelectorAll('details[open]').forEach((answer) => answer.removeAttribute('open'));
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.v7AnswerTab, false));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = (index + direction + tabs.length) % tabs.length;
          activate(tabs[next].dataset.v7AnswerTab, true);
        });
      });

      root.querySelectorAll('details').forEach((answer) => {
        answer.addEventListener('toggle', () => {
          if (!answer.open) return;
          answer.closest('[data-v7-answer-panel]')?.querySelectorAll('details[open]').forEach((other) => {
            if (other !== answer) other.removeAttribute('open');
          });
        });
      });

      activate(tabs[0]?.dataset.v7AnswerTab || 'mirror', false);
    });
  }

  initializeCasaV7AnswerTabs(document);
  document.addEventListener('shopify:section:load', (event) => initializeCasaV7AnswerTabs(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-proof-v6"] && !Shopify.designMode) return;
  try {
    
  class CasaAssuranceV6 extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.panel = this.querySelector('[data-assurance-panel]');
      this.triggers = Array.from(this.querySelectorAll('[data-assurance-trigger]'));
      this.form = this.panel?.querySelector('form');
      if (!this.panel || !this.form || !this.triggers.length) return;

      const result = this.panel.querySelector('[data-assurance-result]');
      const returnedToPanel = [this.panel.id, this.form.id].some(id => location.hash === `#${id}`);
      this.setOpen(Boolean(result || returnedToPanel));
      this.querySelector('[data-assurance-close]').hidden = false;
      this.triggers.forEach(trigger => trigger.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.setOpen(true);
        this.syncContext();
        this.panel.querySelector('h3').focus();
      }, options));
      this.querySelector('[data-assurance-close]').addEventListener('click', () => this.closePanel(), options);
      this.panel.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closePanel();
        }
      }, options);
      window.addEventListener('hashchange', () => {
        if (location.hash === `#${this.panel.id}`) this.setOpen(true);
      }, options);
      document.addEventListener('variant:update', event => {
        if (String(event.detail?.data?.productId) === this.dataset.productId && event.detail?.resource?.id) {
          this.syncContext(event.detail.resource.id);
        }
      }, options);
      this.form.addEventListener('submit', () => this.syncContext(), { ...options, capture: true });
      this.syncContext();
      if (result) result.focus();
    }

    setOpen(open) {
      this.panel.hidden = !open;
      this.triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
    }

    closePanel() {
      this.setOpen(false);
      this.triggers[0].focus();
    }

    syncContext(variantId) {
      const variantInput = this.form.querySelector('[data-assurance-variant]');
      const returnUrl = new URL(location.href);
      const variant = variantId || returnUrl.searchParams.get('variant') || variantInput.value;
      if (variant) returnUrl.searchParams.set('variant', variant);
      returnUrl.searchParams.delete('contact_posted');
      returnUrl.hash = this.panel.id;
      this.form.elements.namedItem('return_to').value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
      variantInput.value = variant;
      const productUrl = new URL(returnUrl.pathname, returnUrl.origin);
      if (variant) productUrl.searchParams.set('variant', variant);
      this.form.querySelector('[data-assurance-product-url]').value = productUrl.href;
    }

    disconnectedCallback() { this.abort?.abort(); }
  }

  if (!customElements.get('casa-assurance-v6')) customElements.define('casa-assurance-v6', CasaAssuranceV6);

  class CasaOpticsV6 extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-optics-playback]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userChoice = null;
      this.playPending = false;
      this.video.controls = false;
      this.video.muted = true;
      this.video.playsInline = true;
      this.button.hidden = false;

      this.button.addEventListener('click', () => {
        this.userChoice = this.video.paused;
        if (!this.observer) this.visible = true;
        this.applyPlayback();
      }, options);
      ['play', 'pause', 'error', 'ended'].forEach((name) => this.video.addEventListener(name, () => this.syncControl(), options));
      document.addEventListener('visibilitychange', () => this.applyPlayback(), options);
      this.motion.addEventListener('change', () => {
        this.userChoice = null;
        this.applyPlayback();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (entry.intersectionRatio >= 0.25) this.visible = true;
          else if (!entry.isIntersecting) this.visible = false;
          this.applyPlayback();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this.video);
      }
      const subscribeToOverlays = () => {
        this.unsubscribeOverlay?.();
        this.unsubscribeOverlay = window.casa?.onOverlayToggle?.(() => this.applyPlayback());
      };
      subscribeToOverlays();
      document.addEventListener('DOMContentLoaded', subscribeToOverlays, { ...options, once: true });
      this.syncControl();
    }

    applyPlayback() {
      const permitted = this.userChoice === true || (this.userChoice !== false && !this.motion.matches);
      if (this.visible && !document.hidden && !window.casa?.overlayOpen?.() && permitted) {
        if (!this.video.paused || this.playPending) return;
        this.playPending = true;
        this.video.play().catch(() => this.syncControl()).finally(() => { this.playPending = false; });
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }

    syncControl() {
      const playing = !this.video.paused;
      const label = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
      this.button.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', label);
      this.button.querySelector('[data-optics-playback-label]').textContent = label;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.unsubscribeOverlay?.();
      this.video?.pause();
    }
  }

  if (!customElements.get('casa-optics-v6')) customElements.define('casa-optics-v6', CasaOpticsV6);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-proof-v7"] && !Shopify.designMode) return;
  try {
    
  class CasaOpticsV7 extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('[data-optics-playback]');
      if (!this.video || !this.button) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.userChoice = null;
      this.video.controls = false;
      this.video.muted = true;
      this.video.playsInline = true;
      this.button.hidden = false;

      this.button.addEventListener('click', () => {
        this.userChoice = this.video.paused;
        if (!this.observer) this.visible = true;
        this.applyPlayback();
      }, options);
      ['play', 'pause', 'error', 'ended'].forEach((name) => this.video.addEventListener(name, () => this.syncControl(), options));
      document.addEventListener('visibilitychange', () => this.applyPlayback(), options);
      this.motion.addEventListener('change', () => {
        this.userChoice = null;
        this.applyPlayback();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          this.applyPlayback();
        }, { threshold: [0, 0.2] });
        this.observer.observe(this.video);
      }
      const subscribeToOverlays = () => {
        this.unsubscribeOverlay?.();
        this.unsubscribeOverlay = window.casa?.onOverlayToggle?.(() => this.applyPlayback());
      };
      subscribeToOverlays();
      document.addEventListener('DOMContentLoaded', subscribeToOverlays, { ...options, once: true });
      this.syncControl();
    }

    applyPlayback() {
      const permitted = this.userChoice === true || (this.userChoice !== false && !this.motion.matches);
      if (this.visible && !document.hidden && !window.casa?.overlayOpen?.() && permitted) {
        this.video.play().catch(() => this.syncControl());
      } else {
        this.video.pause();
      }
    }

    syncControl() {
      const playing = !this.video.paused;
      const label = playing ? this.button.dataset.pauseLabel : this.button.dataset.playLabel;
      this.button.dataset.playing = String(playing);
      this.button.setAttribute('aria-label', label);
      this.button.querySelector('[data-optics-playback-label]').textContent = label;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.unsubscribeOverlay?.();
      this.video?.pause();
    }
  }

  if (!customElements.get('casa-optics-v7')) customElements.define('casa-optics-v7', CasaOpticsV7);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-story-v6"] && !Shopify.designMode) return;
  try {
    
  class CasaOctaSizeV6 extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.options = Array.from(this.querySelectorAll('[data-v6-size-option]'));
      this.hotspots = Array.from(this.querySelectorAll('[data-v6-size-hotspot]'));
      this.labels = Array.from(this.querySelectorAll('[data-v6-size-label]'));
      this.statusPrimary = this.querySelector('[data-v6-size-status-primary]');
      this.statusSecondary = this.querySelector('[data-v6-size-status-secondary]');
      this.selectedRole = this.querySelector('[data-v6-size-selected-role]');
      this.selectedPrimary = this.querySelector('[data-v6-size-selected-primary]');
      this.selectedSecondary = this.querySelector('[data-v6-size-selected-secondary]');
      this.selectedPrice = this.querySelector('[data-v6-size-selected-price]');
      this.selectedCompare = this.querySelector('[data-v6-size-selected-compare]');
      this.selectedPlacement = this.querySelector('[data-v6-size-selected-placement]');
      this.selectedSaving = this.querySelector('[data-v6-size-selected-saving]');
      this.selectedBestseller = this.querySelector('[data-v6-size-selected-bestseller]');
      this.gift = this.querySelector('[data-v6-size-gift]');
      this.formVariant = this.querySelector('[data-v6-size-form-variant]');
      this.atc = this.querySelector('.casa-v6-size__atc');
      this.rail = this.querySelector('[data-v6-size-rail]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.options.forEach((option) => option.addEventListener('click', () => this.select(option)));
      this.hotspots.forEach((hotspot) => hotspot.addEventListener('click', () => {
        const option = this.options.find((item) => item.dataset.v6SizeKey === hotspot.dataset.v6SizeHotspot);
        if (option) this.select(option);
      }));

      this.onVariantUpdate = (event) => {
        const variant = event.detail?.resource;
        if (!variant?.id) return;
        const option = this.options.find((item) => item.dataset.variantId === String(variant.id));
        if (option) this.activate(option);
      };
      document.addEventListener('variant:update', this.onVariantUpdate);

      const initialOption = this.options.find((item) => item.classList.contains('is-selected'));
      if (initialOption) this.updateState(initialOption);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const activeOption = this.options.find((item) => item.classList.contains('is-selected'));
          if (activeOption) this.positionRail(activeOption);
        });
        this.resizeObserver.observe(this);
      }

      if ('IntersectionObserver' in window && !this.reducedMotion) {
        this.entranceObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          window.setTimeout(() => this.classList.add('is-entered'), 180);
          this.entranceObserver.disconnect();
        }, { rootMargin: '120px 0px' });
        this.entranceObserver.observe(this);
      } else {
        this.classList.add('is-entered');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariantUpdate);
      this.entranceObserver?.disconnect();
      this.resizeObserver?.disconnect();
      window.clearTimeout(this.switchTimer);
    }

    select(option) {
      this.activate(option);
      const title = option.dataset.variantTitle;
      const id = option.dataset.variantId;
      const purchase = document.querySelector(this.dataset.purchaseTarget || '#casa-octa-purchase');
      const radio = Array.from(purchase?.querySelectorAll('input[type="radio"]') || []).find((input) => input.value === title);
      const selectOption = Array.from(purchase?.querySelectorAll('select[name="id"] option') || []).find((item) => item.value === id);

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!radio && selectOption) {
        selectOption.parentElement.value = id;
        selectOption.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.dispatchEvent(new CustomEvent('casa:size-guide-select', { bubbles: true, detail: { variantId: id, title } }));
    }

    activate(option) {
      const key = option.dataset.v6SizeKey;
      if (this.pendingKey === key) return;
      if (this.dataset.selectedSize === key) {
        this.updateState(option);
        return;
      }

      window.clearTimeout(this.switchTimer);
      this.pendingKey = key;

      if (this.reducedMotion || !this.classList.contains('is-entered')) {
        this.updateState(option);
        this.pendingKey = '';
        return;
      }

      this.classList.add('is-switching');
      this.switchTimer = window.setTimeout(() => {
        this.updateState(option);
        requestAnimationFrame(() => this.classList.remove('is-switching'));
        this.pendingKey = '';
      }, 170);
    }

    updateState(option) {
      const key = option.dataset.v6SizeKey;
      this.dataset.selectedSize = key;

      this.options.forEach((item) => {
        const active = item === option;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      this.labels.forEach((item) => item.classList.toggle('is-selected', item.dataset.v6SizeLabel === key));
      this.hotspots.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.v6SizeHotspot === key)));

      if (this.statusPrimary) this.statusPrimary.textContent = option.dataset.variantSizePrimary || option.dataset.variantTitle;
      if (this.statusSecondary) this.statusSecondary.textContent = option.dataset.variantSizeSecondary || '';
      if (this.selectedRole) this.selectedRole.textContent = option.dataset.variantRole || '';
      if (this.selectedPrimary) this.selectedPrimary.textContent = option.dataset.variantSizePrimary || option.dataset.variantTitle;
      if (this.selectedSecondary) this.selectedSecondary.textContent = option.dataset.variantSizeSecondary || '';
      if (this.selectedPrice) this.selectedPrice.textContent = option.dataset.variantPrice || '';
      if (this.selectedPlacement) this.selectedPlacement.textContent = option.dataset.variantPlacement || '';

      this.toggleContent(this.selectedCompare, option.dataset.variantCompare);
      this.toggleContent(this.selectedSaving, option.dataset.variantSaving);
      if (this.selectedBestseller) this.selectedBestseller.hidden = option.dataset.variantShowBestseller !== 'true';
      if (this.gift) this.gift.hidden = option.dataset.variantShowGift !== 'true';

      if (this.formVariant) this.formVariant.value = option.dataset.variantId;
      if (this.atc) {
        const available = option.dataset.variantAvailable === 'true';
        this.atc.disabled = !available;
        const price = this.atc.querySelector('.add-to-cart-price .atc-price-num');
        if (price) price.textContent = option.dataset.variantPrice || '';
        const label = this.atc.querySelector('.add-to-cart-text__content > span > span:first-child');
        if (label) label.textContent = available ? option.dataset.variantAtcLabel : this.dataset.soldOutLabel;
        this.atc.setAttribute('aria-label', available ? `${option.dataset.variantAtcLabel} for ${option.dataset.variantPrice}` : `${option.dataset.variantSizePrimary} is sold out`);
      }

      this.positionRail(option);
    }

    toggleContent(element, content) {
      if (!element) return;
      element.textContent = content || '';
      element.hidden = !content;
    }

    positionRail(option) {
      if (!this.rail || !option) return;
      this.rail.style.height = `${option.offsetHeight}px`;
      this.rail.style.transform = `translateY(${option.offsetTop}px)`;
    }
  }

  if (!customElements.get('casa-octa-size-v6')) {
    customElements.define('casa-octa-size-v6', CasaOctaSizeV6);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-octamirror-story-v7"] && !Shopify.designMode) return;
  try {
    
  class CasaOctaSizeV7 extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.options = Array.from(this.querySelectorAll('[data-v7-size-option]'));
      this.hotspots = Array.from(this.querySelectorAll('[data-v7-size-hotspot]'));
      this.labels = Array.from(this.querySelectorAll('[data-v7-size-label]'));
      this.statusPrimary = this.querySelector('[data-v7-size-status-primary]');
      this.statusSecondary = this.querySelector('[data-v7-size-status-secondary]');
      this.selectedRole = this.querySelector('[data-v7-size-selected-role]');
      this.selectedPrimary = this.querySelector('[data-v7-size-selected-primary]');
      this.selectedSecondary = this.querySelector('[data-v7-size-selected-secondary]');
      this.selectedPrice = this.querySelector('[data-v7-size-selected-price]');
      this.selectedCompare = this.querySelector('[data-v7-size-selected-compare]');
      this.selectedPlacement = this.querySelector('[data-v7-size-selected-placement]');
      this.selectedSaving = this.querySelector('[data-v7-size-selected-saving]');
      this.selectedBestseller = this.querySelector('[data-v7-size-selected-bestseller]');
      this.gift = this.querySelector('[data-v7-size-gift]');
      this.formVariant = this.querySelector('[data-v7-size-form-variant]');
      this.atc = this.querySelector('.casa-v7-size__atc');
      this.rail = this.querySelector('[data-v7-size-rail]');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.options.forEach((option) => option.addEventListener('click', () => this.select(option)));
      this.hotspots.forEach((hotspot) => hotspot.addEventListener('click', () => {
        const option = this.options.find((item) => item.dataset.v7SizeKey === hotspot.dataset.v7SizeHotspot);
        if (option) this.select(option);
      }));

      this.onVariantUpdate = (event) => {
        const variant = event.detail?.resource;
        if (!variant?.id) return;
        const option = this.options.find((item) => item.dataset.variantId === String(variant.id));
        if (option) this.activate(option);
      };
      document.addEventListener('variant:update', this.onVariantUpdate);

      const initialOption = this.options.find((item) => item.classList.contains('is-selected'));
      if (initialOption) this.updateState(initialOption);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          const activeOption = this.options.find((item) => item.classList.contains('is-selected'));
          if (activeOption) this.positionRail(activeOption);
        });
        this.resizeObserver.observe(this);
      }

      if ('IntersectionObserver' in window && !this.reducedMotion) {
        this.entranceObserver = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          window.setTimeout(() => this.classList.add('is-entered'), 180);
          this.entranceObserver.disconnect();
        }, { rootMargin: '120px 0px' });
        this.entranceObserver.observe(this);
      } else {
        this.classList.add('is-entered');
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this.onVariantUpdate);
      this.entranceObserver?.disconnect();
      this.resizeObserver?.disconnect();
      window.clearTimeout(this.switchTimer);
    }

    select(option) {
      this.activate(option);
      const title = option.dataset.variantTitle;
      const id = option.dataset.variantId;
      const purchase = document.querySelector(this.dataset.purchaseTarget || '#casa-octa-purchase');
      const radio = Array.from(purchase?.querySelectorAll('input[type="radio"]') || []).find((input) => input.value === title);
      const selectOption = Array.from(purchase?.querySelectorAll('select[name="id"] option') || []).find((item) => item.value === id);

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!radio && selectOption) {
        selectOption.parentElement.value = id;
        selectOption.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.dispatchEvent(new CustomEvent('casa:size-guide-select', { bubbles: true, detail: { variantId: id, title } }));
    }

    activate(option) {
      const key = option.dataset.v7SizeKey;
      if (this.pendingKey === key) return;
      if (this.dataset.selectedSize === key) {
        this.updateState(option);
        return;
      }

      window.clearTimeout(this.switchTimer);
      this.pendingKey = key;

      if (this.reducedMotion || !this.classList.contains('is-entered')) {
        this.updateState(option);
        this.pendingKey = '';
        return;
      }

      this.classList.add('is-switching');
      this.switchTimer = window.setTimeout(() => {
        this.updateState(option);
        requestAnimationFrame(() => this.classList.remove('is-switching'));
        this.pendingKey = '';
      }, 170);
    }

    updateState(option) {
      const key = option.dataset.v7SizeKey;
      this.dataset.selectedSize = key;

      this.options.forEach((item) => {
        const active = item === option;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      this.labels.forEach((item) => item.classList.toggle('is-selected', item.dataset.v7SizeLabel === key));
      this.hotspots.forEach((item) => item.setAttribute('aria-pressed', String(item.dataset.v7SizeHotspot === key)));

      if (this.statusPrimary) this.statusPrimary.textContent = option.dataset.variantSizePrimary || option.dataset.variantTitle;
      if (this.statusSecondary) this.statusSecondary.textContent = option.dataset.variantSizeSecondary || '';
      if (this.selectedRole) this.selectedRole.textContent = option.dataset.variantRole || '';
      if (this.selectedPrimary) this.selectedPrimary.textContent = option.dataset.variantSizePrimary || option.dataset.variantTitle;
      if (this.selectedSecondary) this.selectedSecondary.textContent = option.dataset.variantSizeSecondary || '';
      if (this.selectedPrice) this.selectedPrice.textContent = option.dataset.variantPrice || '';
      if (this.selectedPlacement) this.selectedPlacement.textContent = option.dataset.variantPlacement || '';

      this.toggleContent(this.selectedCompare, option.dataset.variantCompare);
      this.toggleContent(this.selectedSaving, option.dataset.variantSaving);
      if (this.selectedBestseller) this.selectedBestseller.hidden = option.dataset.variantShowBestseller !== 'true';
      if (this.gift) this.gift.hidden = option.dataset.variantShowGift !== 'true';

      if (this.formVariant) this.formVariant.value = option.dataset.variantId;
      if (this.atc) {
        const available = option.dataset.variantAvailable === 'true';
        this.atc.disabled = !available;
        const price = this.atc.querySelector('.add-to-cart-price .atc-price-num');
        if (price) price.textContent = option.dataset.variantPrice || '';
        const label = this.atc.querySelector('.add-to-cart-text__content > span > span:first-child');
        if (label) label.textContent = available ? option.dataset.variantAtcLabel : this.dataset.soldOutLabel;
        this.atc.setAttribute('aria-label', available ? `${option.dataset.variantAtcLabel} for ${option.dataset.variantPrice}` : `${option.dataset.variantSizePrimary} is sold out`);
      }

      this.positionRail(option);
    }

    toggleContent(element, content) {
      if (!element) return;
      element.textContent = content || '';
      element.hidden = !content;
    }

    positionRail(option) {
      if (!this.rail || !option) return;
      this.rail.style.height = `${option.offsetHeight}px`;
      this.rail.style.transform = `translateY(${option.offsetTop}px)`;
    }
  }

  if (!customElements.get('casa-octa-size-v7')) {
    customElements.define('casa-octa-size-v7', CasaOctaSizeV7);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-pdp-films-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.filmsInit === '1') return;
    root.dataset.filmsInit = '1';

    var layers = Array.prototype.slice.call(root.querySelectorAll('.casa-films__layer'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-films-go]'));
    var track  = root.querySelector('[data-films-track]');
    var btn    = root.querySelector('[data-films-toggle]');
    var label  = root.querySelector('[data-films-label]');
    var glow   = root.querySelector('.casa-films__glow');

    var hudName  = root.querySelector('[data-hud-name]');
    var hudHex   = root.querySelector('[data-hud-hex]');
    var hudSw    = root.querySelector('[data-hud-sw]');
    var hudIndex = root.querySelector('[data-hud-index]');
    var capTitle = root.querySelector('[data-cap-title]');

    var total = layers.length;
    if (total < 1) return;

    var stage = root.querySelector('.casa-films__stage');
    if (stage && typeof ResizeObserver === 'function') {
      if (root._filmsRO) root._filmsRO.disconnect();
      var ro = new ResizeObserver(function (entries) {
        var w = entries[0].contentRect.width;
        if (w > 0) root.style.setProperty('--films-stage-w', Math.round(w) + 'px');
      });
      ro.observe(stage);
      root._filmsRO = ro;
    }

    var period = parseFloat(root.dataset.period) || 2;
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = root.dataset.autoplay === '1' && !prefersReducedMotion;
    var t = 0;
    var rafId = null;
    var last = null;
    // IO gate: only run the rAF loop while the section is on-screen.
    // Without IntersectionObserver support we assume in-view (no gate).
    var inView = !('IntersectionObserver' in window);
    // Dirty-check caches so render() skips DOM writes when values are unchanged
    // (between crossfades everything is static — the loop would otherwise
    // rewrite identical styles/text 60×/s).
    var lastGlowHex = null;
    var lastDomIdx = -1;

    function smoothstep(a, b, x) {
      var v = Math.max(0, Math.min(1, (x - a) / (b - a)));
      return v * v * (3 - 2 * v);
    }
    function mixHex(a, b, p) {
      var ah = parseInt(a.slice(1), 16), bh = parseInt(b.slice(1), 16);
      var ar = (ah >> 16) & 255, ag = (ah >> 8) & 255, ab = ah & 255;
      var br = (bh >> 16) & 255, bg = (bh >> 8) & 255, bb = bh & 255;
      var r = Math.round(ar + (br - ar) * p);
      var g = Math.round(ag + (bg - ag) * p);
      var bl = Math.round(ab + (bb - ab) * p);
      return '#' + ((1 << 24) | (r << 16) | (g << 8) | bl).toString(16).slice(1);
    }
    function pad2(n) { return ('0' + n).slice(-2); }

    function render() {
      var cont = t * total;
      var idx = Math.min(Math.floor(cont), total - 1);
      var localT = cont - idx;
      var xfade = smoothstep(0.88, 1, localT);
      var nextIdx = (idx + 1) % total;

      for (var i = 0; i < total; i++) {
        var op = 0;
        if (i === idx) op = 1 - xfade;
        else if (i === nextIdx) op = xfade;
        if (layers[i]._filmsOp !== op) {
          layers[i]._filmsOp = op;
          layers[i].style.opacity = op;
        }
      }

      var cur = layers[idx];
      var nxt = layers[nextIdx];
      var glowHex = mixHex(cur.dataset.hex, nxt.dataset.hex, xfade);

      if (glowHex !== lastGlowHex) {
        lastGlowHex = glowHex;
        glow.style.background = 'radial-gradient(circle at 50% 55%, '
          + glowHex + '40 0%, '
          + glowHex + '2e 18%, '
          + glowHex + '1c 35%, '
          + glowHex + '0e 55%, '
          + 'transparent 80%)';
      }

      var dom    = (xfade > 0.5) ? nxt : cur;
      var domIdx = (xfade > 0.5) ? nextIdx : idx;

      // Everything below depends only on the dominant film — skip until it flips.
      if (domIdx !== lastDomIdx) {
        lastDomIdx = domIdx;
        var domHex = dom.dataset.hex || glowHex;
        var domName = dom.dataset.name || '';

        // Side-bar ambient color flow
        root.style.setProperty('--film-c', domHex);

        // H2 em gradient: 3-stop slice of the sunset palette anchored on the
        // dominant film. prev → curr → next wraps at the ends so each film
        // gets a unique gradient that still reads as part of the same sunset.
        // Snap-syncs to the same moment the dominant photo flips (xfade > 0.5)
        // so the eye sees the gradient and image change together.
        var prevIdx = (domIdx - 1 + total) % total;
        var aheadIdx = (domIdx + 1) % total;
        var prevHex = layers[prevIdx].dataset.hex || domHex;
        var aheadHex = layers[aheadIdx].dataset.hex || domHex;
        root.style.setProperty('--films-em-grad',
          'linear-gradient(90deg, ' + prevHex + ' 0%, ' + domHex + ' 50%, ' + aheadHex + ' 100%)');

        if (hudName)  hudName.textContent  = domName;
        if (hudHex)   hudHex.textContent   = domHex.toUpperCase();
        if (hudSw) {
          hudSw.style.background = domHex;
          hudSw.style.boxShadow  = '0 0 10px ' + domHex;
        }
        if (hudIndex) hudIndex.textContent = pad2(domIdx + 1) + ' / ' + pad2(total);
        if (capTitle) capTitle.textContent = domName;

        for (var j = 0; j < dots.length; j++) {
          if (j === domIdx) dots[j].classList.add('is-on'); else dots[j].classList.remove('is-on');
        }
      }
      if (track) {
        var tv = String(Math.round(t * 1000));
        if (track.value !== tv) track.value = tv;
      }
    }

    function tick(now) {
      if (last == null) last = now;
      var dt = (now - last) / 1000;
      last = now;
      var totalSec = total * period;
      t += dt / totalSec;
      if (t >= 1) t = 0;
      render();
      rafId = requestAnimationFrame(tick);
    }

    // The loop itself only runs while the user wants autoplay AND the
    // section is on-screen (IO-gated) — same pattern as the AuraSphere
    // scene player. `auto` tracks intent; loopOn/loopOff track the rAF.
    function loopOn() {
      if (rafId != null || !auto || !inView) return;
      last = null;
      rafId = requestAnimationFrame(tick);
    }
    function loopOff() {
      if (rafId != null) cancelAnimationFrame(rafId);
      rafId = null;
    }

    function start() {
      auto = true;
      if (btn) { btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); }
      if (label) label.textContent = 'Pause';
      loopOn();
    }
    function stop() {
      auto = false;
      if (btn) { btn.classList.remove('is-on'); btn.setAttribute('aria-pressed', 'false'); }
      if (label) label.textContent = 'Play';
      loopOff();
    }

    if (btn) btn.addEventListener('click', function () { auto ? stop() : start(); });
    if (track) track.addEventListener('input', function (ev) {
      stop();
      t = parseFloat(ev.target.value) / 1000;
      render();
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stop();
        var i = parseInt(dot.dataset.filmsGo, 10) || 0;
        t = (i + 0.05) / total;
        render();
      });
    });

    // Start/stop the rAF loop as the section enters/leaves the viewport,
    // so an off-screen carousel never burns main-thread frames
    // (casa-aurasphere-scenes pattern).
    if ('IntersectionObserver' in window) {
      if (root.__filmsIO) root.__filmsIO.disconnect();
      root.__filmsIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          inView = entry.isIntersecting;
          if (inView) loopOn(); else loopOff();
        });
      }, { threshold: 0.15, rootMargin: '200px' });
      root.__filmsIO.observe(root);
    }

    // Teardown hook for the theme editor (section:unload / re-init).
    root.__filmsTeardown = function () {
      loopOff();
      if (root.__filmsIO) { root.__filmsIO.disconnect(); root.__filmsIO = null; }
      if (root._filmsRO) { root._filmsRO.disconnect(); root._filmsRO = null; }
      root.dataset.filmsInit = '';
    };

    render();
    if (auto) start();
  }

  function bootAll() {
    document.querySelectorAll('.casa-films').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) ev.target.querySelectorAll('.casa-films').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev.target) return;
    ev.target.querySelectorAll('.casa-films').forEach(function (root) {
      if (root.__filmsTeardown) root.__filmsTeardown();
      if (root.__seamlessTeardown) root.__seamlessTeardown();
    });
  });

  /* ── Seamless sunset gradient coordinator (Phoenix §02–§06) ──────────
     Paints ONE scroll-anchored gradient behind the five stacked sections
     and flattens each one's own base + ambient wash, so the whole span
     reads as a single continuous sunset with no section edges. Lives
     entirely here (films-picker is Phoenix-only) — the shared stats/moods
     sections are only restyled at runtime, their files untouched. */
  function initSeamless(root) {
    if (!root || root.dataset.seamless !== '1' || root.__seamlessInit) return;
    var filmsWrap = root.closest('.shopify-section');
    if (!filmsWrap) return;
    root.__seamlessInit = '1';

    // The group, in order: §02 films → §03 stats → §04 arms → §05 moods →
    // §06 form. Walk siblings from films' wrapper, collecting each that
    // holds one of these roots, and stop at the first that doesn't (FAQ).
    var GROUP = ['.casa-films', '.casa-st', '.casa-arms', '.casa-am', '.casa-form', '.casa-faq2'];
    // Section-wide ambient wash layers to hide (chrome, not product light).
    var AMBIENT = ['.casa-films__bg-glow', '.casa-arms__ambient', '.casa-am__ambient'];

    var wraps = [];
    var roots = [];
    var w = filmsWrap;
    var wanted = 0;
    while (w && wanted < GROUP.length) {
      if (!w.classList || !w.classList.contains('shopify-section')) { w = w.nextElementSibling; continue; }
      var el = w.querySelector(GROUP[wanted]);
      if (!el) break; // chain broke — reached FAQ or a reorder; stop.
      wraps.push(w);
      roots.push(el);
      wanted++;
      w = w.nextElementSibling;
    }
    if (wraps.length < 2) { root.__seamlessInit = ''; return; } // nothing to blend

    var container = filmsWrap.parentElement;
    var prevContainerPos = container.style.position;
    if (getComputedStyle(container).position === 'static') container.style.position = 'relative';

    // Backdrop lives in the SAME container as the sections so z-index is
    // reliable across one stacking context. Sections float above it.
    var backdrop = document.createElement('div');
    backdrop.className = 'casa-phx-sunset';
    backdrop.setAttribute('aria-hidden', 'true');
    backdrop.style.cssText = 'position:absolute;left:0;right:0;top:0;z-index:0;pointer-events:none;';
    backdrop.style.background = 'linear-gradient(180deg, ' + (root.dataset.seamlessStops || '#0E0C1A 0%, #0A0A0F 100%') + ')';
    container.insertBefore(backdrop, filmsWrap);

    // Flatten: transparentize each section's own base + hide ambient washes;
    // lift content above the backdrop. Saved for teardown.
    var restore = [];
    wraps.forEach(function (wr) { restore.push([wr, wr.style.position, wr.style.zIndex]); wr.style.position = 'relative'; wr.style.zIndex = '1'; });
    roots.forEach(function (el) {
      restore.push([el, el.style.background, null]);
      el.style.setProperty('background', 'transparent', 'important');
    });
    var hidden = [];
    AMBIENT.forEach(function (sel) {
      roots.forEach(function (el) {
        el.querySelectorAll(sel).forEach(function (g) { hidden.push([g, g.style.display]); g.style.display = 'none'; });
      });
    });

    function place() {
      var first = wraps[0].getBoundingClientRect();
      var last = wraps[wraps.length - 1].getBoundingClientRect();
      /* Position and size BOTH from rects, measured against the container.
         Previously `top` came from wraps[0].offsetTop while `height` came from
         rects. offsetTop is relative to the element's OWN offsetParent, which
         isn't necessarily this container — when it wasn't, the backdrop was
         shifted (measured 160px up on the live PDP), so it over-covered the
         top and fell 160px short at the bottom, leaving the tail of the FAQ
         with no gradient and a visible colour step. Same basis for both
         values keeps the layer locked to the section range. (2026-07-16) */
      var cRect = container.getBoundingClientRect();
      /* BLEED: overshoot the group top and bottom. The neighbours (buy box
         above, recommendations below) are opaque, so the overshoot is never
         seen — but it means a few px of drift, or a re-layout landing between
         two place() passes, can no longer expose a hard edge where the
         gradient starts or stops. Cheap insurance against the "beam" class of
         bug entirely. (2026-07-16) */
      var BLEED = 320;
      var top = first.top - cRect.top - BLEED;
      var height = (last.bottom - first.top) + BLEED * 2;
      backdrop.style.top = Math.round(top) + 'px';
      backdrop.style.height = Math.round(height) + 'px';
    }
    // Coalesce resize + all 5 ResizeObserver callbacks that can fire in one
    // frame into a single place() so we don't force-reflow N times per frame.
    var placeRaf = null;
    function schedulePlace() {
      if (placeRaf) return;
      placeRaf = requestAnimationFrame(function () { placeRaf = null; place(); });
    }
    place();

    // Heights settle after images/fonts/carousel paint — recompute on a
    // few passes + on any group resize + window resize.
    var raf = requestAnimationFrame(place);
    var t1 = setTimeout(place, 300), t2 = setTimeout(place, 1200);
    window.addEventListener('resize', schedulePlace);
    var ro = null;
    if (typeof ResizeObserver === 'function') {
      ro = new ResizeObserver(schedulePlace);
      wraps.forEach(function (wr) { ro.observe(wr); });
      /* ALSO observe <body>. The group observer only fires when a group
         section changes SIZE — but the common failure is the group being
         PUSHED DOWN by content above it (the buy box carries ~130 images;
         each one that decodes shifts everything below). The group's own size
         never changes, so the observer stayed silent and the backdrop kept a
         stale top: measured 382px high, which left a hard gradient edge over
         the buy box and another 382px short of the FAQ end — the two "beams"
         (merchant 2026-07-16). Watching body catches any page-height change. */
      ro.observe(document.body);
    }
    /* Belt-and-braces for the same problem: images finishing after the last
       timed pass. Cheap — one-shot listener per not-yet-complete image. */
    var imgs = [].slice.call(document.images);
    imgs.forEach(function (im) {
      if (!im.complete) {
        im.addEventListener('load', schedulePlace, { once: true });
        im.addEventListener('error', schedulePlace, { once: true });
      }
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedulePlace);

    root.__seamlessTeardown = function () {
      cancelAnimationFrame(raf); clearTimeout(t1); clearTimeout(t2);
      if (placeRaf) cancelAnimationFrame(placeRaf);
      window.removeEventListener('resize', schedulePlace);
      if (ro) ro.disconnect();
      if (backdrop.parentNode) backdrop.parentNode.removeChild(backdrop);
      container.style.position = prevContainerPos;
      restore.forEach(function (r) {
        if (r[2] === null) r[0].style.background = r[1] || '';
        else { r[0].style.position = r[1] || ''; r[0].style.zIndex = r[2] || ''; }
      });
      hidden.forEach(function (h) { h[0].style.display = h[1] || ''; });
      root.__seamlessInit = '';
      root.__seamlessTeardown = null; // idempotent: can't double-run
    };
  }
  function bootSeamless() { document.querySelectorAll('.casa-films').forEach(initSeamless); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSeamless);
  else bootSeamless();
  // Rebuild the whole group treatment on ANY section load/unload — the
  // backdrop spans FIVE sections, so a reorder/remove/settings-change of a
  // MIDDLE group section (not just §02) must recompute. Tear down + re-init
  // each films root; rAF-debounced so the editor DOM settles first, and it
  // no-ops cleanly if §02 itself was the section removed.
  var resyncRaf = null;
  function resyncSeamless() {
    if (resyncRaf) cancelAnimationFrame(resyncRaf);
    resyncRaf = requestAnimationFrame(function () {
      resyncRaf = null;
      document.querySelectorAll('.casa-films').forEach(function (root) {
        if (root.__seamlessTeardown) root.__seamlessTeardown();
        initSeamless(root);
      });
    });
  }
  document.addEventListener('shopify:section:load', resyncSeamless);
  document.addEventListener('shopify:section:unload', resyncSeamless);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["casa-sizing"] && !Shopify.designMode) return;
  try {
    
function casaSzInit(ROOT) {
  if (!ROOT || ROOT.dataset.casaSzInit === '1') return;
  ROOT.dataset.casaSzInit = '1';

  var $$ = function (sel) { return Array.prototype.slice.call(ROOT.querySelectorAll(sel)); };
  var $ = function (sel) { return ROOT.querySelector(sel); };

  var DATA = {
    S: { name: 'Small',  inches: 11.8, cm: 30, h_in: 11.8, h_cm: 30, depth_in: '1.6', depth_cm: '4 cm', use: 'Vanities, nooks, desks',             price: 249, was: 349, popular: false },
    M: { name: 'Medium', inches: 19.7, cm: 50, h_in: 19.7, h_cm: 50, depth_in: '2.0', depth_cm: '5 cm', use: 'Bedrooms, entryways, hallways',      price: 299, was: 399, popular: false },
    L: { name: 'Large',  inches: 27.6, cm: 70, h_in: 27.6, h_cm: 70, depth_in: '2.4', depth_cm: '6 cm', use: 'Above sofas, gaming rooms, lounges', popular: true  }
  };

  $$('[data-casa-sz-chip]').forEach(function (chip) {
    var k = chip.dataset.casaSzChip;
    if (!DATA[k]) return;
    if (chip.dataset.hIn)     DATA[k].h_in     = chip.dataset.hIn;
    if (chip.dataset.hCm)     DATA[k].h_cm     = chip.dataset.hCm;
    if (chip.dataset.depthIn) DATA[k].depth_in = chip.dataset.depthIn;
    if (chip.dataset.depthCm) DATA[k].depth_cm = chip.dataset.depthCm;
    if (chip.dataset.variantId) DATA[k].variant = chip.dataset.variantId;
    if (chip.dataset.variantAvailable) DATA[k].available = chip.dataset.variantAvailable !== 'false';
    if (chip.dataset.variantUrl) DATA[k].url = chip.dataset.variantUrl;
    /* Price strings are FORMATTED IN LIQUID and only carried here. Never
       build money in JS — the shopper's market decides the symbol, the
       decimal/thousands separators and whether a currency code shows,
       and none of that is knowable client-side. */
    if (chip.dataset.price) DATA[k].price_html = chip.dataset.price;
    DATA[k].was_html = chip.dataset.was || '';
    /* Liquid owns the copy; the table above is only the fallback. */
    if (chip.dataset.use) DATA[k].use = chip.dataset.use;
    /* The variant picker's radios are keyed by OPTION VALUE ("27.6\" / 70cm"),
       not by variant id — this is what lets a chip drive the picker. */
    if (chip.dataset.variantOption) DATA[k].optionValue = chip.dataset.variantOption;
  });

  var nameEl   = $('[data-casa-sz-name]');
  var inchesEl = $('[data-casa-sz-inches]');
  var hInEl    = $('[data-casa-sz-h-in]');
  var dInEl    = $('[data-casa-sz-d-in]');
  var cmEl     = $('[data-casa-sz-cm]');
  var hCmEl    = $('[data-casa-sz-h-cm]');
  var dCmEl    = $('[data-casa-sz-d-cm]');
  var useEl    = $('[data-casa-sz-use]');
  var popEl    = $('[data-casa-sz-pop]');
  var buyEl      = $('.casa-sz__buy');
  var priceEl    = $('[data-casa-sz-price]');
  var wasEl      = $('[data-casa-sz-was]');
  var atcEl      = $('[data-casa-sz-atc]');
  var atcLabelEl = atcEl ? atcEl.querySelector('.casa-sz__atc-label') : null;
  var mirrors  = $$('[data-casa-sz-mirror]');
  var chips    = $$('[data-casa-sz-chip]');
  var current  = ROOT.dataset.default || 'L';


  var lits = $$('[data-casa-sz-lit]');
  var hots = $$('[data-casa-sz-hot]');

  var fieldEl    = $('.casa-sz__field');
  var plateEl    = $('[data-casa-sz-plate]');
  var bracketEl  = $('[data-casa-sz-bracket]');
  var bkHEl      = $('[data-casa-sz-bk-h]');
  var bkWEl      = $('[data-casa-sz-bk-w]');
  var depthBoxEl = $('[data-casa-sz-depth-box]');
  var depthPlEl  = $('[data-casa-sz-depth-plate]');

  // The bracket is MEASURED, not computed. The plate's aspect-ratio changes
  // at <=640px and the mirror's own aspect-ratio changes per shape, so a
  // percentage scheme would be wrong on both axes. offsetLeft/offsetTop give
  // the mirror's CENTRE — each carries translate(-50%,-50%), which moves the
  // paint but not the offset box — so half the box comes back off each.
  // Absent in photo mode, where there is no field and no mirrors to measure.
  function placeBracket(k) {
    if (!bracketEl || !fieldEl) return;
    var m = fieldEl.querySelector('[data-casa-sz-mirror="' + k + '"]');
    if (!m) return;
    var w = m.offsetWidth;
    var h = m.offsetHeight;
    if (!w || !h) return;
    bracketEl.style.setProperty('--bk-l', (m.offsetLeft - w / 2) + 'px');
    bracketEl.style.setProperty('--bk-t', (m.offsetTop - h / 2) + 'px');
    bracketEl.style.setProperty('--bk-w', w + 'px');
    bracketEl.style.setProperty('--bk-h', h + 'px');

    // Tiers are keyed off the plate's real width, not a media query: the
    // plate is a column in a grid, so its width and the viewport's are not
    // the same number.
    var pw = plateEl ? plateEl.clientWidth : 0;
    var compact = pw > 0 && pw < 460;
    var tiny = pw > 0 && pw < 300;
    bracketEl.classList.toggle('is-compact', compact);
    bracketEl.classList.toggle('is-tiny', tiny);
    if (depthBoxEl) {
      depthBoxEl.classList.toggle('is-compact', compact);
      depthBoxEl.classList.toggle('is-tiny', tiny);
    }

    // The height figure lives in the gutter between this mirror and its left
    // neighbour, and that gutter is the tightest space on the plate: 5.45% of
    // the plate width with Large selected, which is 19px at a 350px phone
    // plate. Measured there, the figure cleared the Medium mirror by 5.1px —
    // technically not overlapping, visually touching.
    //
    // So the rule is the measurement, not a breakpoint: keep the figure only
    // where it clears the neighbour by MIN_CLEAR. That stays correct across
    // all 5 shapes, both plate aspect-ratios, and whichever platform mono the
    // stack falls through to — a hardcoded px width would be re-tuned by hand
    // every time one of those moved. Square frames mean height IS width, so
    // dropping it costs no fact and the copy column still states the triple.
    if (bkHEl) {
      var MIN_CLEAR = 10;
      // Un-hide BEFORE measuring. Measuring the figure while its own class
      // has it display:none reads offsetWidth 0, which shrinks `need` below
      // `available` and shows it again — then the next call measures the
      // visible box, hides it, and it flips back. The rule would oscillate
      // and settle on whatever the previous state happened to be.
      bracketEl.classList.remove('is-noheight');
      // Judge the TIGHTEST size on this plate, not the selected one. Per
      // selection, a 350px plate keeps the figure on Small and Medium and
      // drops it on Large — so tapping through the sizes makes a dimension
      // blink out, which reads as a bug rather than as a decision. One
      // verdict per plate: either this plate has room for a height figure or
      // it does not.
      var worstGutter = Infinity;
      mirrors.forEach(function (mirror) {
        var left = mirror.offsetLeft - mirror.offsetWidth / 2;
        var neighbourRight = 0;
        mirrors.forEach(function (other) {
          if (other === mirror) return;
          var oRight = other.offsetLeft + other.offsetWidth / 2;
          if (oRight <= left && oRight > neighbourRight) neighbourRight = oRight;
        });
        worstGutter = Math.min(worstGutter, left - neighbourRight);
      });
      var need = parseFloat(getComputedStyle(bracketEl).getPropertyValue('--bk-gap'))
        + bkHEl.offsetWidth / 2 + MIN_CLEAR;
      if (worstGutter < need) bracketEl.classList.add('is-noheight');
    }

    // Each rail breaks around its own figure, so it needs the figure's real
    // box — which depends on the font that actually loaded and on the tier
    // class just toggled above, not on anything computable in CSS. Read AFTER
    // the toggles so the measurement matches the size being rendered.
    // The vertical figure runs down its rail because of writing-mode, NOT the
    // rotate() — so its LENGTH is its offsetHeight. Drop the writing-mode and
    // keep the rotate and this reads the wrong axis.
    // bkHEl is absent by design on hexagon-flat and triangle, which draw at
    // aspect 1.1547 (see the markup comment on the height rail).
    if (bkHEl) {
      bracketEl.style.setProperty('--bk-cut-v', (bkHEl.offsetHeight / 2 + 5) + 'px');
    }
    if (bkWEl) {
      bracketEl.style.setProperty('--bk-cut-w', (bkWEl.offsetWidth / 2 + 6) + 'px');
    }
  }

  /* ── TWO-WAY SIZE SYNC ───────────────────────────────────────────────
     The strip, the buy box and the sticky bar are three surfaces showing
     one decision, so they have to agree.

     Picker -> strip is free: Horizon dispatches 'variant:update' on
     document with the variant at detail.resource (NOT detail.variant —
     casa-sticky-cart.js documents that trap, it froze the bar for a
     while). We just relight the matching chip.

     Strip -> picker is pushed IMMEDIATELY — never debounced. This used
     to wait 700ms so rapid comparison taps wouldn't each trigger the
     picker's full-page refetch (~1-2s, ~1MB — docs/variant-picker-
     architecture.md 6.6). That debounce was a money bug. The theme's
     variant system is a single-writer design with a lock: ~100ms after
     the picker learns of a change it DISABLES the buy buttons, and
     re-enables them only once the form's variant id is consistent
     again (measured 2026-08-24: disabled at 101ms, re-enabled with the
     new id at 1210ms). Wrong-item adds are impossible inside that lock.
     The debounce held the shopper's choice OUTSIDE it: for 700ms the
     picker knew nothing, no lock engaged, the buy buttons stayed live
     with the stale id — tap Large here, hit the sticky bar's ADD within
     that window, and the cart got Small (measured). Dispatching at once
     puts the tap on the picker's own guarded path instead.

     Rapid S -> M -> L taps are exactly what the picker's AbortController
     exists for — each new change cancels the in-flight fetch, so the
     last tap wins and the aborted transfers stop downloading.

     The strip itself never waits on any of this — syncBuy() has already
     repainted synchronously, so the chips feel instant and the rest of
     the page reconciles behind them. */
  function pushToPicker(k) {
    var d = DATA[k];
    if (!d || !d.variant || !d.optionValue) return;
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var radios = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== d.optionValue) continue;
      /* Skip only when the RADIO is already on this size. The form's
         hidden id is a TRAILING indicator (it updates ~1.2s later, after
         the fetch) — guarding on it here would skip a legitimate push
         mid-flight: S selected, tap L (fetch starts), tap S again — the
         form still says S, a form-guard skips, the L fetch lands, and
         the strip is stranded out of sync. The radio is the picker's
         intent and is always current. */
      if (radios[i].checked) return;
      /* Set state + fire 'change' — deliberately NOT .click().
         Clicking the label focuses its radio, and that radio lives in the
         buy box at the top of the page. Focusing an off-screen control
         makes the browser scroll it into view, so a tap down here threw
         the shopper back up the page (measured: scrollY 2630 -> 402, with
         no scrollTo call anywhere — it was the focus, and document height
         never changed).
         'change' is what the picker actually binds
         (assets/variant-picker.js:46, delegated on <variant-picker>), and
         its handler reads event.target, so dispatching on the radio gives
         it exactly what a real change would. Verified: scroll holds and
         activeElement never leaves <body>. */
      radios[i].checked = true;
      radios[i].dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  /* Picker -> strip. */
  function onVariantUpdate(e) {
    var v = e && e.detail ? e.detail.resource : null;
    if (!v || !v.id) return;
    var id = String(v.id);
    /* URL reconcile — a belt for a rare stock fluke. The picker defers its
       ?variant= writes (yieldToMainThread -> replaceState), and under
       main-thread contention from rapidly aborted changes they can land
       out of order: observed once 2026-08-24 — URL held Medium while the
       form, strip and cart all settled on Large, so a refresh or a shared
       link would reopen the wrong size. Two instrumented reproductions of
       the same sequence came out FIFO-correct, so this can't be chased —
       but settle IS ground truth, so on every settle the URL is made to
       agree with it. Only when a variant param already exists: a bare URL
       stays bare, we never add state the shopper didn't create. */
    try {
      var u = new URL(window.location.href);
      var uv = u.searchParams.get('variant');
      if (uv && uv !== id) {
        u.searchParams.set('variant', id);
        history.replaceState(history.state, '', u.toString());
      }
    } catch (err) { /* cosmetic guard — never fatal */ }
    for (var k in DATA) {
      if (DATA[k] && String(DATA[k].variant) === id) {
        if (k !== current) select(k, { fromPicker: true });
        return;
      }
    }
  }
  document.addEventListener('variant:update', onVariantUpdate);

  /* This listener is on `document`, so unlike everything else in this
     component it does NOT die with the section's DOM. The theme editor
     mounts and unmounts sections all day; without this the listeners
     stack up and one picker change re-runs select() N times. */
  document.addEventListener('shopify:section:unload', function onSyncUnload(e) {
    if (e.detail && e.detail.sectionId !== ROOT.dataset.sectionId) return;
    document.removeEventListener('variant:update', onVariantUpdate);
    document.removeEventListener('shopify:section:unload', onSyncUnload);
  });

  /* Point the BUY row at the size that is currently lit. */
  function syncBuy(d) {
    if (!buyEl) return;
    /* A size with no variant behind it (product ships fewer than three)
       hides the row rather than leaving the previous size's price sitting
       under a button that would add a different mirror. */
    if (!d.variant) { buyEl.hidden = true; return; }
    buyEl.hidden = false;

    if (priceEl) priceEl.textContent = d.price_html || '';
    if (wasEl) {
      var w = d.was_html || '';
      wasEl.textContent = w;
      wasEl.hidden = !w;
    }
    if (!atcEl) return;

    atcEl.setAttribute('data-casa-sz-atc', d.variant);
    if (d.url) atcEl.setAttribute('href', d.url);

    var avail = d.available !== false;
    if (avail) {
      atcEl.removeAttribute('data-soldout');
      atcEl.removeAttribute('aria-disabled');
    } else {
      atcEl.setAttribute('data-soldout', '1');
      atcEl.setAttribute('aria-disabled', 'true');
    }
    /* Only touch the label while the button is idle. Mid-add it is showing
       "Adding…" / "Added ✓" under its own timer, and writing here would
       blank the feedback the shopper is reading. */
    if (atcEl.getAttribute('aria-busy') !== 'true' && atcLabelEl) {
      atcLabelEl.textContent = avail ? 'Add to cart' : 'Sold out';
    }
  }

  function select(k, opts) {
    var d = DATA[k];
    if (!d) return;
    syncBuy(d);
    /* A select() that CAME from the variant picker must not push back to it,
       or the two sit in a loop trading 1 MB page fetches. */
    if (!(opts && opts.fromPicker)) pushToPicker(k);
    nameEl.textContent = d.name;
    inchesEl.textContent = d.inches;
    if (hInEl)  hInEl.textContent  = d.h_in;
    if (dInEl)  dInEl.textContent  = d.depth_in;
    cmEl.textContent = d.cm;
    if (hCmEl)  hCmEl.textContent  = d.h_cm;
    if (dCmEl)  dCmEl.textContent  = d.depth_cm;
    useEl.textContent = d.use;
    popEl.hidden = !d.popular;
    mirrors.forEach(function (m) {
      m.classList.toggle('is-on', m.dataset.casaSzMirror === k);
    });
    chips.forEach(function (c) {
      c.classList.toggle('is-on', c.dataset.casaSzChip === k);
    });
    lits.forEach(function (el) {
      el.classList.toggle('is-on', el.dataset.casaSzLit === k);
    });
    if (bkHEl) bkHEl.textContent = d.h_in + '″';
    if (bkWEl) bkWEl.textContent = d.inches + '″';
    if (depthPlEl) depthPlEl.textContent = d.depth_in;
    placeBracket(k);
    current = k;
  }

  mirrors.forEach(function (m) {
    m.addEventListener('click', function () { select(m.dataset.casaSzMirror); });
  });
  chips.forEach(function (c) {
    c.addEventListener('click', function () { select(c.dataset.casaSzChip); });
  });
  hots.forEach(function (h) {
    h.addEventListener('click', function () { select(h.dataset.casaSzHot); });
  });

  /* ── Add to cart ────────────────────────────────────────────────────
     Ported from sections/casa-sizing-cube.liquid, which has been serving
     this exact contract on the Cube PDP. The <a href> is the no-JS path;
     everything below is the enhancement over it.

     The listener is on ROOT, not document, so it is torn down with the
     section on a theme-editor unmount — no global to leak and nothing to
     clean up in an unload handler. */
  if (atcEl) {
    /* This is a static "javascript" block — no Liquid runs here, so routes
       come off the root as data-*. Locale-prefixed storefronts serve
       /en-de/cart/add, so the literal "/cart/add.js" is wrong there. */
    var CART_ADD_URL = ROOT.dataset.cartAddUrl || '/cart/add';
    var CART_URL = ROOT.dataset.cartUrl || '/cart';

    /* Ask for the cart + header sections back in the same round-trip, so
       the drawer and the cart-count bubble are already re-rendered by the
       time the drawer opens. */
    function collectSectionIds() {
      var ids = {};
      document.querySelectorAll('[data-section-id], [id^="shopify-section-"]').forEach(function (el) {
        var sid = el.dataset.sectionId || (el.id && el.id.replace(/^shopify-section-/, ''));
        if (!sid) return;
        var tag = (el.tagName || '').toLowerCase();
        var cls = (el.className || '').toString();
        if (/cart/i.test(tag) || /cart/i.test(cls) || /header/i.test(cls)) ids[sid] = 1;
      });
      return Object.keys(ids);
    }

    /* The theme has been through Horizon and Dawn cart drawers and the
       merchant can swap the cart app again, so this probes rather than
       assumes. Falling through to /cart is the floor — the item is
       already added by this point, so the worst case is a page load, not
       a lost add. */
    function openAnyDrawer() {
      var horizon = document.querySelector('cart-drawer-component');
      if (horizon) {
        try { if (typeof horizon.open === 'function') { horizon.open(); return true; } } catch (e) {}
        try { if (typeof horizon.showDialog === 'function') { horizon.showDialog(); return true; } } catch (e) {}
      }
      var dawn = document.querySelector('cart-drawer, #cart-drawer, #CartDrawer');
      if (dawn) {
        try { if (typeof dawn.open === 'function') { dawn.open(); return true; } } catch (e) {}
        try { if (typeof dawn.show === 'function') { dawn.show(); return true; } } catch (e) {}
        dawn.classList.add('active', 'is-open', 'animate');
        dawn.classList.remove('hidden');
        dawn.setAttribute('open', '');
        if (dawn.tagName.toLowerCase() === 'dialog') {
          try { dawn.showModal(); return true; } catch (e) {}
        }
        return true;
      }
      var cartBtn = document.querySelector('.casa-header__cart-btn, [aria-label*="cart" i][role="button"], [aria-label*="cart" i].header__icon, a[href$="/cart"]');
      if (cartBtn) { try { cartBtn.click(); return true; } catch (e) {} }
      return false;
    }

    function broadcastCartUpdate(response, variantId) {
      var detail = {
        resource: response,
        sourceId: 'casa-sz-' + (ROOT.dataset.sectionId || ''),
        data: {
          source: 'casa-sizing',
          itemCount: 1,
          variantId: variantId,
          sections: response && response.sections ? response.sections : {}
        }
      };
      ['cart:update', 'cart:refresh', 'cart-update', 'cart:item-added', 'cart-drawer:refresh'].forEach(function (name) {
        try { document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail })); } catch (e) {}
      });
    }

    ROOT.addEventListener('click', function (e) {
      var cta = e.target.closest('[data-casa-sz-atc]');
      if (!cta || !ROOT.contains(cta)) return;

      /* Sold out keeps its href for the no-JS path, so the refusal has to
         happen here — otherwise a keyboard Enter on the greyed button
         navigates away. */
      if (cta.hasAttribute('data-soldout')) { e.preventDefault(); return; }

      var vid = cta.getAttribute('data-casa-sz-atc');
      if (!/^\d+$/.test(vid)) return; /* invalid — let the href navigate */

      e.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      cta.setAttribute('aria-busy', 'true');

      var labelEl = cta.querySelector('.casa-sz__atc-label');
      var orig = labelEl ? labelEl.textContent : '';
      function setLabel(t) { if (labelEl) labelEl.textContent = (t == null ? orig : t); }
      setLabel('Adding…');

      var sectionIds = collectSectionIds();
      var payload = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
      if (sectionIds.length) payload.sections = sectionIds.join(',');

      fetch(CART_ADD_URL + '.js', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) { if (!res.ok && res.status !== 422) throw new Error('network'); return res.json(); })
        .then(function (response) {
          /* 422 carries a real reason (out of stock, cart limit). Show
             Shopify's own message rather than a generic failure. */
          if (response && response.status) {
            setLabel(response.message || 'Unavailable');
            setTimeout(function () { setLabel(null); cta.removeAttribute('aria-busy'); }, 2200);
            return;
          }
          broadcastCartUpdate(response, vid);
          setLabel('Added ✓');
          setTimeout(function () {
            if (!openAnyDrawer()) { window.location.href = CART_URL; }
          }, 60);
          setTimeout(function () { setLabel(null); cta.removeAttribute('aria-busy'); }, 1500);
        })
        .catch(function () {
          /* Network died. Fall back to the href the button always had —
             the shopper lands on the PDP with this size selected. */
          cta.removeAttribute('aria-busy');
          setLabel(null);
          window.location.href = cta.getAttribute('href');
        });
    });
  }

  // The tunnel's hue drift is `infinite`, so left ungated it keeps
  // compositing a filter while the shopper is three sections away and
  // eats scroll frame budget. Only let it run while the plate is on
  // screen. No observer support -> leave it running (the old behaviour).
  if ('IntersectionObserver' in window) {
    var plate = ROOT.querySelector('[data-casa-sz-plate]');
    if (plate) {
      var driftIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ROOT.classList.toggle('is-live', e.isIntersecting); });
      }, { rootMargin: '120px 0px' });
      driftIO.observe(plate);
      document.addEventListener('shopify:section:unload', function onUnload(e) {
        if (e.detail && e.detail.sectionId !== ROOT.dataset.sectionId) return;
        driftIO.disconnect();
        document.removeEventListener('shopify:section:unload', onUnload);
      });
    }
  } else {
    ROOT.classList.add('is-live');
  }

  // The bracket is written in px, so it has to be re-placed whenever the
  // plate reflows. Observing the PLATE rather than the window because the
  // plate is a grid column — it changes width when the copy column wraps,
  // with no viewport change at all. Safe against a resize loop: everything
  // the callback moves is absolutely positioned inside the field, so it
  // cannot feed back into the plate's own size.
  if (bracketEl && plateEl && 'ResizeObserver' in window) {
    // isConnected guard: shopify:section:unload covers the theme editor, but
    // a Section Rendering API swap or an app rewriting the DOM replaces the
    // node without firing it, leaving this observer holding a detached target
    // forever. Self-heal on the first delivery after that happens.
    var bracketRO = new ResizeObserver(function () {
      if (!ROOT.isConnected) { bracketRO.disconnect(); return; }
      placeBracket(current);
    });
    bracketRO.observe(plateEl);
    document.addEventListener('shopify:section:unload', function onBracketUnload(e) {
      if (e.detail && e.detail.sectionId !== ROOT.dataset.sectionId) return;
      bracketRO.disconnect();
      document.removeEventListener('shopify:section:unload', onBracketUnload);
    });
  }



  /* fromPicker: the server already rendered this size BECAUSE the buy box
     has it selected. Pushing here would fire a page fetch on every load. */
  select(ROOT.dataset.default || 'L', { fromPicker: true });
}

function casaSzInitAll(scope) {
  (scope || document).querySelectorAll('.casa-sz').forEach(casaSzInit);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { casaSzInitAll(); });
} else {
  casaSzInitAll();
}
document.addEventListener('shopify:section:load', function (e) {
  if (e.target) casaSzInitAll(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
